import React from 'react'

export function CheckSuccessIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={13}
      height={10}
      viewBox="0 0 13 10"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#86F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M1 5.312L4.398 9 12 1"
      />
    </svg>
  )
}

export function StepIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M5 23a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM21.13 2.164a.5.5 0 0 1 .74.672l-2.5 2.75a.5.5 0 0 1-.724.018l-1.5-1.5a.5.5 0 0 1 .708-.708l1.129 1.13 2.147-2.362zm0 8a.5.5 0 0 1 .74.672l-2.5 2.75a.5.5 0 0 1-.724.018l-1.5-1.5a.5.5 0 1 1 .708-.708l1.129 1.13 2.147-2.362zm0 8a.5.5 0 0 1 .74.672l-2.5 2.75a.5.5 0 0 1-.724.018l-1.5-1.5a.5.5 0 1 1 .708-.708l1.129 1.13 2.147-2.362z"
      />
    </svg>
  )
}

export function ShevroneIcon({className, stroke}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={6}
        d="M16 12l-8 8 8-8-8-8z"
      />
    </svg>
  )
}

export function AccountIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M20 18c0-2.66-5.33-4-8-4s-8 1.34-8 4a9.983 9.983 0 0 0 8 4 9.985 9.985 0 0 0 8-3.999V18zm-8-6c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 12C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z"
      />
    </svg>
  )
}

export function LogoGa({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={70}
      height={30}
      viewBox="0 0 200 80"
    >
      <g fill="none" fillRule="nonzero">
        <g fill="#757575">
          <path
            d="M75.359 47.705l4.36 11.538H71.27l4.089-11.538zm-1.636-3.846l-9.539 25.274h3.543l2.453-6.868h10.63l2.453 6.868h3.543l-9.54-25.274h-3.543zM125.236 69.133h3.27V43.859h-3.27zM91.712 54.298c1.09-1.648 3.27-3.022 5.451-3.022 4.36 0 6.541 3.022 6.541 7.418v10.714h-3.27V59.243c0-3.571-1.908-4.945-4.361-4.945-2.726 0-4.634 2.747-4.634 5.22v9.615h-3.27V51.55h3.27l.273 2.747zM106.43 63.913c0-3.846 3.543-6.044 7.631-6.044 2.453 0 4.089.55 4.634 1.1v-.55c0-2.747-2.18-4.12-4.361-4.12-1.908 0-3.543.823-4.089 2.472l-2.998-1.374c.546-1.648 2.726-4.12 7.087-4.12 4.088 0 7.631 2.472 7.631 7.417v10.439h-2.998V66.66h-.272c-.818 1.374-2.726 3.022-5.724 3.022-3.543 0-6.541-2.197-6.541-5.769m12.265-2.197s-1.363-1.1-4.089-1.1c-3.27 0-4.633 1.924-4.633 3.297 0 1.923 1.908 2.747 3.543 2.747 2.453 0 5.179-2.197 5.179-4.944M133.14 76.825l3.816-9.066-6.814-15.933h3.27l5.179 12.087 5.178-12.087h3.271l-10.63 24.999zM181.11 57.595c-.818-2.198-2.726-3.572-4.634-3.572-2.726 0-5.179 2.473-5.179 6.044 0 3.572 2.453 6.044 5.179 6.044 1.908 0 3.816-1.374 4.633-3.297l2.726 1.649c-1.363 3.022-4.089 4.945-7.36 4.945-4.633 0-8.448-4.121-8.448-9.34 0-5.495 3.815-9.341 8.449-9.341 3.27 0 5.996 1.923 7.359 4.945l-2.726 1.923zM192.829 69.682c4.36 0 6.541-2.472 6.541-5.494 0-6.593-9.54-4.12-9.54-7.967 0-1.373 1.091-2.198 2.999-2.198 1.908 0 3.816.825 4.633 2.198l1.908-1.923c-1.09-1.373-4.088-3.296-6.814-3.296-4.088 0-6.268 2.472-6.268 5.494 0 6.318 9.812 4.12 9.812 7.417 0 1.649-1.09 2.747-3.271 2.747-2.18 0-3.27-1.373-4.36-2.747l-2.454 1.923c1.635 1.649 4.088 3.846 6.814 3.846zM161.758 69.133h3.27V51.55h-3.27zM163.12 43.035c1.364 0 2.181 1.099 2.181 2.198 0 1.373-1.09 2.197-2.18 2.197s-2.18-1.099-2.18-2.197c0-1.1 1.09-2.198 2.18-2.198zM158.487 66.386l.545 2.472h-3.27c-2.998 0-4.361-2.198-4.361-5.494v-8.516h-3.27V51.55h3.27v-5.22h3.27v5.22h3.816v3.297h-3.815v9.065c0 2.473 1.907 2.473 3.815 2.473z"/>
        </g>
        <g fill="#757575">
          <path
            d="M80.013 16.584v4.045h9.543c-.273 2.158-1.09 3.776-2.181 4.855-1.364 1.349-3.545 2.967-7.362 2.967-5.726 0-10.361-4.585-10.361-10.519 0-5.664 4.635-10.519 10.36-10.519 3.273 0 5.454 1.349 7.09 2.697l2.727-2.697c-2.454-2.157-5.454-4.045-9.816-4.045-7.907 0-14.724 6.473-14.724 14.294 0 7.822 6.817 14.295 14.724 14.295 4.362 0 7.634-1.348 10.088-4.046 2.727-2.697 3.545-6.203 3.545-9.17 0-.809 0-1.888-.273-2.427h-13.36v.27zM104.28 13.347c-5.18 0-9.27 3.776-9.27 9.17s4.09 9.17 9.27 9.17 9.27-4.045 9.27-9.17c0-5.394-4.09-9.17-9.27-9.17zm0 14.834c-2.727 0-5.18-2.427-5.18-5.664 0-3.236 2.453-5.664 5.18-5.664 2.726 0 5.18 2.158 5.18 5.664s-2.454 5.664-5.18 5.664zM148.996 15.235c-1.09-1.079-2.727-2.158-5.18-2.158-4.636 0-8.726 4.046-8.726 9.17 0 5.125 4.09 9.17 8.725 9.17 2.182 0 4.09-1.078 4.908-2.157h.273v1.349c0 3.506-1.909 5.394-4.908 5.394-2.454 0-4.09-1.888-4.635-3.237l-3.545 1.349c1.09 2.427 3.817 5.394 8.18 5.394 4.908 0 8.998-2.697 8.998-9.71V13.077h-3.817v2.158h-.273zM144.36 28.18c-2.727 0-4.908-2.427-4.908-5.664 0-3.236 2.181-5.664 4.908-5.664 2.726 0 4.908 2.428 4.908 5.664 0 3.237-2.182 5.664-4.908 5.664zM124.456 13.347c-5.18 0-9.27 3.776-9.27 9.17s4.09 9.17 9.27 9.17c5.181 0 9.27-4.045 9.27-9.17.274-5.394-4.089-9.17-9.27-9.17zm0 14.834c-2.726 0-5.18-2.427-5.18-5.664 0-3.236 2.454-5.664 5.18-5.664 2.727 0 5.181 2.158 5.181 5.664s-2.454 5.664-5.18 5.664zM156.085 3.637h4.09v28.05h-4.09zM171.354 28.181c-2.181 0-3.545-1.079-4.635-2.697l12.542-5.124-.545-1.08c-.818-2.157-3.272-5.933-7.907-5.933-4.908 0-8.725 3.776-8.725 9.17 0 5.125 4.09 9.17 9.27 9.17 4.363 0 6.816-2.697 7.907-4.045l-3.272-2.158c-1.09 1.618-2.454 2.697-4.635 2.697zm-.273-11.328c1.636 0 3 .81 3.545 2.158l-8.453 3.506c0-4.045 2.727-5.664 4.908-5.664z"/>
        </g>
        <path
          fill="#F9AB00"
          d="M40.526 12.642v48.033c0 5.374 3.755 8.37 7.737 8.37 3.684 0 7.737-2.548 7.737-8.37v-47.67C56 8.079 52.316 5 48.263 5c-4.052 0-7.737 3.395-7.737 7.642z"
        />
        <g fill="#E37400" transform="translate(0 29.38)">
          <path
            d="M20.263 7.642v23.652c0 5.375 3.754 8.37 7.737 8.37 3.684 0 7.737-2.548 7.737-8.37V8.006C35.737 3.078 32.053 0 28 0s-7.737 3.395-7.737 7.642z"/>
          <ellipse cx="7.737" cy="32.022" rx="7.737" ry="7.642"/>
        </g>
      </g>
    </svg>
  )
}

export function GaSymbol({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
    >
      <g fill="none">
        <path
          fill="#F9AB00"
          d="M52 19.063v41.25c0 4.615 2.911 7.187 6 7.187 2.857 0 6-2.188 6-7.188V19.376c0-4.231-2.857-6.875-6-6.875s-6 2.916-6 6.563z"
        />
        <g fill="#E37400" transform="translate(16 32.5)">
          <path
            d="M17.449 6.686v20.696c0 4.703 3.233 7.324 6.662 7.324 3.173 0 6.662-2.23 6.662-7.324V7.005C30.773 2.694 27.601 0 24.111 0c-3.49 0-6.662 2.97-6.662 6.686z"/>
          <ellipse cx="6.662" cy="28.019" rx="6.662" ry="6.686"/>
        </g>
      </g>
    </svg>
  )
}

export function YandexMarketIcon({className, width = 35, height = 35}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#4B72B8"
          d="M16 16v5.277h6.777L33.373 51l26.112-7.172c1.584-.463 2.705-1.06 3.365-1.791.66-.73 1.043-1.949 1.15-3.655v-13.2H30.566L26.985 16H16z"
        />
        <path
          fill="#000"
          d="M52.056 64c-2.178 0-3.943-1.79-3.943-4s1.765-4 3.943-4S56 57.79 56 60s-1.766 4-3.944 4zm-22.112 0C27.766 64 26 62.21 26 60s1.766-4 3.944-4 3.943 1.79 3.943 4-1.765 4-3.943 4z"
        />
      </g>
    </svg>
  )
}

export function YandexDirectIcon({className, width = 35, height = 35}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#EFB30E" d="M65 49.383L68 61H58l-2.838-11.617z"/>
        <path
          fill="#FFCC02"
          d="M16 16h49v33.383H52.016v3.503h-9.572v-3.503h-3.73V64h-9.5V49.383h-3.79V64H16z"
        />
        <path
          fill="#000"
          d="M25 26h30v1.83H25V26zm0 5.085h30v1.83H25v-1.83zm0 5.084h18.913V38H25v-1.83z"
        />
      </g>
    </svg>
  )
}

export function MyTargetIcon({className, width = 35, height = 35}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 80 80"
    >
      <path
        fill="#FC2C39"
        fillRule="evenodd"
        d="M32.97 52.681c-.047.036-.08.056-.107.082-.55.52-1.065 1.072-1.5 1.696-.29.412-.538.847-.697 1.329a2.72 2.72 0 0 0 .89 2.97.976.976 0 0 0 .2.127c.262.117.495.014.59-.258.03-.09.05-.185.07-.278.19-.843.29-1.7.374-2.558.07-.73.127-1.464.177-2.197.02-.292.003-.587.003-.913zM.102 35.65c.073-.857.228-1.693.584-2.481.176-.389.4-.744.703-1.046.602-.602 1.34-.818 2.168-.766.119.007.238.016.354.041.362.081.627.292.793.628.151.305.22.633.23.971.022.863.036 1.726.056 2.589.002.111.008.225.034.332.051.213.192.3.407.272a.648.648 0 0 0 .412-.219 3.74 3.74 0 0 0 .434-.566c.284-.489.54-.994.816-1.488.424-.758.853-1.513 1.286-2.266.184-.32.425-.595.715-.825.954-.755 2.385-.51 3.095.274.277.306.432.667.478 1.075.099.867.12 1.736.086 2.609-.013.366.001.735.017 1.102.01.213.064.424.293.505.216.075.365-.071.49-.215.226-.257.444-.521.654-.792.6-.774 1.182-1.563 1.793-2.328.347-.434.726-.845 1.112-1.246a4.68 4.68 0 0 1 .713-.592c.54-.373 1.153-.466 1.792-.398.196.021.392.062.58.118.963.285 1.533 1.04 1.544 2.054.003.263-.026.526-.048.789-.077.923-.16 1.846-.236 2.77-.126 1.52-.21 3.044-.192 4.572.001.128-.005.257.011.383.037.296.212.41.483.294.173-.073.346-.167.49-.287.292-.244.579-.498.844-.771a8.751 8.751 0 0 0 1.31-1.759.958.958 0 0 0 .125-.5c-.003-.727-.007-1.455.01-2.182.021-.854.07-1.708.225-2.551.133-.726.334-1.43.668-2.09.112-.22.236-.436.385-.631.613-.805 1.434-1.113 2.423-1.01.333.035.657.1.966.23.827.348 1.325.978 1.471 1.86.169 1.019.034 1.994-.558 2.866-.29.428-.445.894-.484 1.407-.034.454-.093.906-.117 1.36-.048.891.017 1.773.259 2.635.07.249.17.482.327.687.337.442.83.593 1.353.411.275-.095.508-.257.715-.46.333-.327.583-.714.804-1.122.437-.806.718-1.67.91-2.562.246-1.147.467-2.3.718-3.445.135-.615.3-1.224.47-1.83.102-.363.282-.694.496-1.004.81-1.175 2.137-1.312 3.22-.622.06.038.115.085.177.121.707.42 1.022 1.073 1.136 1.867.094.659-.016 1.289-.181 1.917l-.747 2.823c-.144.543-.201 1.099-.232 1.658-.067 1.228-.13 2.457-.192 3.685-.006.124.006.25.01.402.11-.05.19-.082.267-.12 1.5-.741 3.075-1.25 4.716-1.56a6.171 6.171 0 0 1 1.677-.1c1.112.095 1.9.879 2.13 1.776.18.696.373 1.388.672 2.043 1.61 3.527 4.268 5.778 8.023 6.683.88.213 1.78.295 2.684.275 5.366-.123 9.67-3.879 10.881-8.725.3-1.197.397-2.41.317-3.637-.034-.51-.122-1.015-.196-1.52-.181-1.229.687-2.46 1.896-2.706a2.433 2.433 0 0 1 2.889 1.976c.26 1.43.35 2.87.236 4.32a16.469 16.469 0 0 1-7.398 12.54 16.023 16.023 0 0 1-5.819 2.354 15.442 15.442 0 0 1-3.708.27c-3.586-.185-6.795-1.395-9.59-3.681-1.791-1.465-3.196-3.249-4.243-5.32-.043-.086-.086-.172-.136-.254-.393-.649-.959-.856-1.668-.596-.692.254-1.358.568-2 .933-.67.381-1.304.817-1.909 1.297a.427.427 0 0 0-.173.32c-.084.85-.173 1.7-.264 2.549-.103.945-.204 1.89-.317 2.833-.107.896-.216 1.792-.346 2.684-.253 1.723-.557 3.436-1.136 5.085a8.478 8.478 0 0 1-.814 1.728c-.498.79-1.175 1.328-2.096 1.526-.184.04-.367.083-.551.124h-.38c-.06-.018-.12-.036-.18-.052-.336-.09-.68-.153-1.006-.272-.689-.252-1.303-.65-1.899-1.073-1.153-.819-2.136-1.805-2.86-3.035-1.046-1.78-1.383-3.685-.934-5.716.257-1.162.767-2.211 1.428-3.19.83-1.231 1.85-2.288 2.963-3.258a29.455 29.455 0 0 1 3.217-2.417c.161-.106.238-.216.247-.417.024-.534.077-1.067.116-1.6.006-.088.031-.182-.033-.304-.066.132-.115.23-.166.327-.526 1.003-1.242 1.831-2.23 2.391-.779.441-1.61.562-2.476.322-.675-.186-1.233-.574-1.695-1.097-.454-.513-.883-1.05-1.226-1.645-.206-.357-.362-.743-.54-1.116l-.097-.196c-.066.103-.109.177-.158.246-.35.493-.684.999-1.057 1.473-.377.479-.827.882-1.388 1.14-.064.03-.122.074-.18.116-.9.647-1.9.817-2.958.556-1.234-.304-2.028-1.084-2.274-2.36a8.474 8.474 0 0 1-.137-1.451c-.018-1.039-.001-2.078.001-3.117 0-.346-.128-.507-.454-.602a.71.71 0 0 0-.614.092 1.623 1.623 0 0 0-.417.382 3.312 3.312 0 0 0-.385.685c-.284.701-.56 1.407-.813 2.12-.332.933-.658 1.865-1.105 2.75-.572 1.134-1.786 1.618-2.974 1.257-.808-.245-1.364-.764-1.543-1.624a8.017 8.017 0 0 1-.148-1.018c-.066-.871 0-1.74.06-2.61.042-.59.068-1.18.084-1.77.01-.37-.295-.606-.652-.525a.953.953 0 0 0-.654.475 7.08 7.08 0 0 0-.298.6c-.425.98-.85 1.96-1.265 2.944-.328.779-.639 1.565-.96 2.347-.135.327-.31.63-.55.89-.603.654-1.357.907-2.217.758-.91-.159-1.576-.926-1.677-1.903-.07-.667-.081-1.338-.134-2.008-.314-3.957-.091-7.528-.064-7.845zm72.966-13.338c0 .625-.003 1.25 0 1.874.002.256.011.512.028.768.038.587.316.889.892.968.18.025.363.04.545.04 1.532.003 3.064 0 4.596.004.157 0 .32.012.47.053.301.08.442.31.392.619a1.14 1.14 0 0 1-.319.653 878.787 878.787 0 0 0-3.757 3.786c-.572.579-1.247.955-2.046 1.096-.202.036-.41.057-.615.058a199.74 199.74 0 0 1-2.738-.012.509.509 0 0 0-.397.167 2767.88 2767.88 0 0 1-6.053 6.057c-.126.125-.163.235-.125.417a5.07 5.07 0 0 1-3.53 5.946c-2.87.824-5.853-1.065-6.34-4.024-.442-2.68 1.249-5.217 3.879-5.81a4.842 4.842 0 0 1 2.378.057c.146.04.245.021.357-.091 1.986-1.995 3.975-3.986 5.967-5.974a.512.512 0 0 0 .162-.402c-.01-.912-.028-1.825-.014-2.737.016-1.022.393-1.901 1.11-2.626 1.29-1.304 2.583-2.605 3.874-3.907l.016-.017c.23-.237.52-.298.83-.268.184.018.309.144.357.313.048.167.072.345.077.518.01.392.004.785.004 1.177v1.297zM61.57 29.118c-.281-.044-.563-.082-.842-.134a11.634 11.634 0 0 0-3.124-.139 11.45 11.45 0 0 0-9.011 5.834c-.358.647-.883 1.075-1.611 1.253-1.31.32-2.666-.532-2.93-1.841a2.348 2.348 0 0 1 .256-1.66c1.823-3.261 4.46-5.643 7.916-7.132a15.93 15.93 0 0 1 3.96-1.119 16.394 16.394 0 0 1 2.938-.172c.992.03 1.972.147 2.944.346 1.035.212 1.934 1.09 1.934 2.335 0 1.563-1.31 2.443-2.43 2.43z"
      />
    </svg>
  )
}

export function GoogleAdsIcon({className, width = 35, height = 35}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FBBC06"
          d="M44.706 15.724a9.336 9.336 0 0 1 3.428 12.793l-18.79 32.31a9.454 9.454 0 0 1-12.873 3.449 9.336 9.336 0 0 1-3.428-12.793l18.79-32.31a9.454 9.454 0 0 1 12.873-3.449z"
        />
        <path
          fill="#34A853"
          d="M25.853 48.075l.059.034a9.302 9.302 0 0 1 3.415 12.747A9.42 9.42 0 0 1 16.5 64.293l-.059-.034a9.302 9.302 0 0 1-3.415-12.747 9.42 9.42 0 0 1 12.827-3.437z"
        />
        <path
          fill="#4285F4"
          d="M35.294 15.724a9.454 9.454 0 0 1 12.874 3.45l18.79 32.309a9.336 9.336 0 0 1-3.429 12.793 9.454 9.454 0 0 1-12.873-3.45l-18.79-32.309a9.336 9.336 0 0 1 3.428-12.793z"
        />
      </g>
    </svg>
  )
}

export function VkIcon({className, width, height}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
    >
      <path
        fill="#4A76A8"
        fillRule="nonzero"
        d="M64.952 48.24c5.148 4.938 6.22 7.352 6.394 7.649 2.125 3.661-2.356 3.948-2.356 3.948l-8.587.129s-1.855.376-4.28-1.356c-3.216-2.276-7.61-8.213-9.967-7.44-2.396.78-1.633 7.005-1.633 7.005s.02.761-.521 1.375c-.6.643-1.758.396-1.758.396H39.77s-9.166.04-16.642-8.015C14.986 43.155 8.176 26.74 8.176 26.74s-.415-1.04.03-1.594c.511-.623 1.892-.613 1.892-.613h9.186s.86.119 1.478.594c.522.386.802 1.118.802 1.118s1.11 3.057 3.081 6.58c3.835 6.867 5.622 8.37 6.926 7.628 1.893-1.078 1.323-9.706 1.323-9.706s.038-3.137-.956-4.532c-.773-1.088-2.212-1.405-2.85-1.494-.521-.06.329-1.306 1.43-1.86 1.651-.831 4.578-.89 8.026-.851 2.686.03 3.7-.01 3.7-.01 3.168.792 2.096 3.859 2.096 11.18 0 2.356-.416 5.66 1.226 6.749.706.485 3.236.554 7.535-7.015 2.047-3.592 3.66-6.966 3.66-6.966s.348-.762.86-1.079c.54-.336 1.256-.336 1.256-.336l9.668.05s2.908-.377 3.371.989c.493 1.425-1.188 3.918-5.129 9.37-6.49 8.955-7.215 8.124-1.835 13.298z"
      />
    </svg>
  )
}

export function FbIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
    >
      <path
        fill="#4267B2"
        fillRule="nonzero"
        d="M61.436 16H18.66A2.658 2.658 0 0 0 16 18.64v42.704A2.658 2.658 0 0 0 18.66 64h23.047V45.44H35.44v-7.28h6.267v-5.344c0-6.192 3.798-9.6 9.327-9.6 1.869 0 3.735.096 5.594.288v6.4h-3.815c-3.013 0-3.606 1.424-3.606 3.52v4.736h7.212l-.93 7.264h-6.41V64h12.277c.704 0 1.379-.28 1.875-.779A2.638 2.638 0 0 0 64 61.344V18.64A2.642 2.642 0 0 0 61.356 16h.08z"
      />
    </svg>
  )
}

export function DinRemIcon({className, width = 35, height = 35}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
    >
      <path
        fill="#0091F2"
        fillRule="nonzero"
        d="M5 38.957V16h8.434c7.906 0 13.506 4.745 13.506 11.462 0 6.716-5.6 11.495-13.506 11.495H5zm6.43-5.865h3.115c3.447 0 5.9-2.339 5.9-5.614 0-3.274-2.453-5.58-5.9-5.58H11.43v11.194zm24.913 5.865V16h7.314v22.957h-7.314zm16.717 0V16h6.488l8.964 12.297V16H75v22.957h-6.488L59.548 26.66v12.297H53.06zM25.896 64h-7.449l-4.887-6.917h-2.022V64H5V41.043h11.088c5.19 0 8.864 3.309 8.864 8.02 0 3.275-1.753 5.848-4.584 7.151L25.896 64zM11.454 46.941v4.278h3.96c1.53 0 2.628-.903 2.628-2.14 0-1.235-1.098-2.138-2.629-2.138h-3.959zm35.337-.117H34.582v2.573h11.12v5.781h-11.12v3.041h12.209V64H27.985V41.043h18.806v5.781zM49.925 64V41.043h6.435l6.103 10.96 6.103-10.96H75V64h-6.434V51.703l-6.103 10.96-6.103-10.96V64h-6.435z"
      />
    </svg>
  )
}

export function CriteoIcon({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 80 80"
    >
      <path
        fill="#FF8F1C"
        fillRule="nonzero"
        d="M17.833 23.369c-1.537.015-2.931-.871-3.532-2.245a3.606 3.606 0 0 1 .792-4.027 3.876 3.876 0 0 1 4.135-.824c1.423.564 2.355 1.906 2.36 3.399a3.617 3.617 0 0 1-1.089 2.604 3.837 3.837 0 0 1-2.666 1.093zm44.412 40.63c-1.536.016-2.93-.87-3.53-2.242a3.606 3.606 0 0 1 .785-4.024 3.876 3.876 0 0 1 4.13-.832c1.424.56 2.36 1.898 2.37 3.389.007 2.023-1.672 3.67-3.755 3.685V64zm-6.6-5.412H45.352c-2.585 0-4.683-2.032-4.69-4.543V25.438c0-4.111-3.433-7.444-7.666-7.444H24.42V21.3h8.147a4.749 4.749 0 0 1 3.334 1.343 4.475 4.475 0 0 1 1.356 3.25v28.555c0 4.111 3.433 7.445 7.667 7.445h10.72v-3.306z"
      />
    </svg>
  )
}

export function AddItemIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 12V4v8h8-8zm0 0v8-8H4h8z"
      />
    </svg>
  )
}

export function RemoveItemIcon({
                                 className,
                                 width = 24,
                                 height = 24,
                                 stroke = '#000',
                               }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 12l8-8-8 8 8 8-8-8zm0 0l-8 8 8-8-8-8 8 8z"
      />
    </svg>
  )
}

export function ResetIcon({
                            className,
                            width = 24,
                            height = 24,
                            stroke = '#000',
                          }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 12l8-8-8 8 8 8-8-8zm0 0l-8 8 8-8-8-8 8 8z"
      />
    </svg>
  )
}

export function OkIcon({
                         className,
                         width = 24,
                         height = 24,
                         stroke = '#000',
                       }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 11.956l6.75 6.545 11.25-12"
      />
    </svg>
  )
}

export function HelpIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zM7 8.463c0 .327.128.631.385.912.257.282.572.422.945.422.633 0 1.063-.402 1.29-1.206.24-.769.533-1.35.88-1.746.347-.395.887-.592 1.62-.592.627 0 1.138.195 1.535.587.397.391.595.872.595 1.441 0 .292-.065.562-.195.812-.13.249-.29.475-.48.677-.19.203-.498.504-.925.903-.487.455-.873.848-1.16 1.18a3.985 3.985 0 0 0-.69 1.152c-.173.438-.26.956-.26 1.554 0 .477.118.836.355 1.078.237.242.528.363.875.363.667 0 1.063-.37 1.19-1.11.073-.35.128-.593.165-.732.037-.138.088-.277.155-.416a2.37 2.37 0 0 1 .305-.46c.137-.166.318-.36.545-.58.82-.784 1.388-1.34 1.705-1.672a4.86 4.86 0 0 0 .82-1.18c.23-.455.345-.985.345-1.59 0-.769-.202-1.48-.605-2.135-.403-.655-.975-1.173-1.715-1.554-.74-.38-1.593-.571-2.56-.571-1.04 0-1.95.228-2.73.683-.78.456-1.373 1.03-1.78 1.724-.407.694-.61 1.38-.61 2.056zM12.015 20c.392 0 .737-.134 1.036-.401.3-.268.449-.636.449-1.104a1.45 1.45 0 0 0-.429-1.064A1.43 1.43 0 0 0 12.015 17c-.425 0-.784.144-1.076.431a1.433 1.433 0 0 0-.439 1.064c0 .475.151.844.453 1.109.303.264.657.396 1.062.396z"
      />
    </svg>
  )
}

export function HowIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
    >
      <path
        fill="#000"
        fillRule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1A7 7 0 1 1 8 1a7 7 0 0 1 0 14zM4.667 5.642c0 .218.085.42.256.608a.82.82 0 0 0 .63.281c.423 0 .71-.268.86-.804.16-.512.356-.9.587-1.164.231-.263.591-.395 1.08-.395.418 0 .759.13 1.023.392.265.26.397.581.397.96 0 .195-.043.376-.13.542a2.035 2.035 0 0 1-.32.452c-.127.135-.332.335-.617.601-.324.304-.582.566-.773.787-.191.22-.344.476-.46.768a2.807 2.807 0 0 0-.173 1.036c0 .318.079.557.236.719a.784.784 0 0 0 .584.242c.444 0 .709-.247.793-.74.049-.233.086-.396.11-.488.024-.093.059-.185.103-.278a1.58 1.58 0 0 1 .204-.306c.09-.111.212-.24.363-.388.547-.522.926-.893 1.137-1.114a3.24 3.24 0 0 0 .546-.786c.154-.304.23-.657.23-1.06 0-.513-.134-.987-.403-1.424a2.825 2.825 0 0 0-1.143-1.036c-.494-.253-1.063-.38-1.707-.38-.693 0-1.3.152-1.82.455-.52.304-.916.687-1.187 1.15-.27.462-.406.919-.406 1.37zm3.343 7.691c.261 0 .492-.089.691-.267.2-.179.299-.424.299-.736a.967.967 0 0 0-.286-.709.954.954 0 0 0-.704-.288.984.984 0 0 0-.718.288.955.955 0 0 0-.292.709c0 .317.1.563.302.74.202.175.438.263.708.263z"
      />
    </svg>
  )
}

export function Pencile({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fill="#000"
        fillRule="evenodd"
        d="M17.96 8.9L16.59 7.53a.75.75 0 0 0-1.06 1.061l1.368 1.369-8.335 8.335c-.847.963-1.775.94-2.785-.07l-.002-.002-.003-.002c-1.008-1.01-1.032-1.938-.07-2.785L17.142 4 20 6.86 17.96 8.9zM3.199 21.977A.99.99 0 0 1 2.022 20.8l1.153-5.38a.798.798 0 0 1 .012-.059c.043-.166.175-.33.305-.46L16.104 2.29a.99.99 0 0 1 1.402 0l4.204 4.204a.99.99 0 0 1 0 1.402L9.098 20.508c-.131.13-.293.262-.46.304a.798.798 0 0 1-.058.013l-5.381 1.153z"
      />
    </svg>
  )
}

export function LogoDs({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 300 300"
    >
      <defs>
        <ellipse id="a" cx="148.408" cy="219.893" rx={150} ry={54}/>
        <path
          id="b"
          d="M138.404 251.387c35.248 12.137 67.029 12.663 70.985 1.175 3.955-11.488-21.412-30.64-56.66-42.777s-67.03-12.663-70.985-1.175c-3.956 11.489 21.412 30.64 56.66 42.777zm-6.429 15.975c77.206 26.584 147.297 27.027 158.158 1.282-.112.41-.238.818-.377 1.223-9.71 28.198-84.584 30.573-162.913 3.602C48.513 246.498-3.61 200.395 6.1 172.196c.14-.404.292-.803.456-1.196-7.291 26.975 48.213 69.778 125.42 96.362z"
        />
        <path
          id="c"
          d="M290.727 267.074c7.059-28.267-47.923-71.79-124.738-98.239-74.898-25.79-143.433-26.01-157.782-1.326a24.5 24.5 0 0 1 .593-1.995c5.597-16.253 27.73-25.026 58.673-25.941 9.946-5.694 23.236-9.056 38.558-9.892 20.266-10.615 48.002-12.518 75.348-3.102 27.713 9.542 48.586 28.493 57.839 49.676 10.88 9.757 18.809 20.163 22.974 30.365 23.82 19.771 35.86 40.312 30.264 56.565a24.621 24.621 0 0 1-1.73 3.89zM96.912 200.703c13.382-1.514 33.93 1.546 55.817 9.082 21.437 7.381 39.22 17.357 48.974 26.626-8.56 6.615-32.102 5.624-57.586-3.151-25.15-8.66-44.144-22.13-47.205-32.557zM199 108c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm36-43c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm37-24a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <use
          fill="#FC0"
          transform="rotate(19 148.408 219.893)"
          xlinkHref="#a"
        />
        <use fill="#FFF" xlinkHref="#b"/>
        <use fill="#86F" xlinkHref="#c"/>
      </g>
    </svg>
  )
}

export function LogoHelp({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 300 300"
    >
      <defs>
        <ellipse id="a" cx="148.408" cy="219.893" rx={150} ry={54}/>
        <path
          id="b"
          d="M138.404 251.387c35.248 12.137 67.029 12.663 70.985 1.175 3.955-11.488-21.412-30.64-56.66-42.777s-67.03-12.663-70.985-1.175c-3.956 11.489 21.412 30.64 56.66 42.777zm-6.429 15.975c77.206 26.584 147.297 27.027 158.158 1.282-.112.41-.238.818-.377 1.223-9.71 28.198-84.584 30.573-162.913 3.602C48.513 246.498-3.61 200.395 6.1 172.196c.14-.404.292-.803.456-1.196-7.291 26.975 48.213 69.778 125.42 96.362z"
        />
        <path
          id="c"
          d="M290.727 267.074c7.059-28.267-47.923-71.79-124.738-98.239-74.898-25.79-143.433-26.01-157.782-1.326a24.5 24.5 0 0 1 .593-1.995c5.597-16.253 27.73-25.026 58.673-25.941 9.946-5.694 23.236-9.056 38.558-9.892 20.266-10.615 48.002-12.518 75.348-3.102 27.713 9.542 48.586 28.493 57.839 49.676 10.88 9.757 18.809 20.163 22.974 30.365 23.82 19.771 35.86 40.312 30.264 56.565a24.621 24.621 0 0 1-1.73 3.89zM96.912 200.703c13.382-1.514 33.93 1.546 55.817 9.082 21.437 7.381 39.22 17.357 48.974 26.626-8.56 6.615-32.102 5.624-57.586-3.151-25.15-8.66-44.144-22.13-47.205-32.557zM199 108c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm36-43c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm37-24a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <use
          fill="#bbbbbb"
          transform="rotate(19 148.408 219.893)"
          xlinkHref="#a"
        />
        <use fill="#FFF" xlinkHref="#b"/>
        <use fill="#000000" xlinkHref="#c"/>
      </g>
    </svg>
  )
}

export function DescDS({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 200"
    >
      <path
        d="M87.5 107.2H65l-4.5-20.3c-.4-1.8-1-3.1-1.8-3.7-.8-.6-2.2-.9-4-.9h-6.6v24.9H27V38.9c6.7-.7 16.4-1 29-1 10.3 0 17.7 1.5 22.1 4.6 4.5 3 6.7 8.4 6.7 16.2 0 9.9-4.6 15.3-13.9 16.2v.6c6.2.8 9.9 4.4 11.2 10.7l5.4 21zm-39.4-40h7.4c3.1 0 5.2-.5 6.2-1.4 1-.9 1.5-2.8 1.5-5.6s-.5-4.7-1.5-5.6c-1-.9-3.1-1.4-6.2-1.4h-7.4v14zm75.1-29.6c8.1 0 14.4 1 18.9 3 4.5 2 7.7 5.6 9.8 10.7 2.1 5.1 3.2 12.4 3.2 21.8s-1.1 16.7-3.2 21.8c-2.1 5.1-5.4 8.7-9.8 10.7-4.5 2-10.7 3-18.9 3-8.1 0-14.3-1-18.8-3s-7.7-5.6-9.8-10.7c-2.1-5.1-3.2-12.4-3.2-21.8s1.1-16.7 3.2-21.8c2.1-5.1 5.4-8.7 9.8-10.7 4.5-2 10.8-3 18.8-3zm7.4 19.8c-1.2-2.6-3.7-3.9-7.4-3.9s-6.2 1.3-7.4 3.9c-1.2 2.6-1.8 7.8-1.8 15.7 0 7.9.6 13.1 1.8 15.7s3.7 3.9 7.4 3.9 6.2-1.3 7.4-3.9c1.2-2.6 1.8-7.8 1.8-15.7 0-7.9-.6-13.1-1.8-15.7zm89.1-18.5h18.9c4.8 0 7.3 2.5 7.5 7.4l2.4 60.9h-19.3L227.1 55h-1.5l-6.7 34.8c-.7 4.4-3.4 6.5-8.1 6.5h-11.1c-4.7 0-7.4-2.2-8.2-6.5L184.7 55h-1.5l-1.7 52.3h-19.3l2.4-60.9c.2-4.9 2.7-7.4 7.5-7.4h18.5c4.6 0 7.3 2.2 8.1 6.6l4.9 27.1c.3 2.1.7 5.5 1.1 10.2h.9c0-.2.1-1.6.4-4.3.3-2.6.5-4.6.7-5.9l4.7-27.1c.9-4.4 3.6-6.7 8.3-6.7zm59.3 68.3h-21.3V38.9H279v68.3zM57.2 159l.7 5.3c-3.2 1.3-7.2 2-12 2-5.8 0-9.9-1.3-12.3-3.9-2.4-2.6-3.6-7-3.6-13.3 0-6.3 1.2-10.7 3.6-13.3 2.4-2.6 6.5-3.9 12.3-3.9 4.6 0 8.3.6 11.4 1.9l-.9 5.1c-2.2-.1-5.2-.1-9-.1-3.4 0-5.7.7-7 2.2-1.3 1.5-1.9 4.2-1.9 8.2 0 4 .6 6.8 1.9 8.3 1.3 1.5 3.6 2.2 7 2.2 3.5-.1 6.8-.3 9.8-.7zm37.9-6.4H81.8c.3 2.8 1.1 4.7 2.4 5.7 1.3 1 3.4 1.4 6.3 1.4 3.3 0 7.2-.3 11.7-.8l.7 5.2c-3.1 1.5-7.5 2.2-13.4 2.2s-10.1-1.3-12.6-3.9c-2.5-2.6-3.7-7-3.7-13.2 0-6.3 1.2-10.8 3.7-13.3 2.4-2.5 6.5-3.8 12.1-3.8 5.2 0 8.9.9 11.3 2.8 2.3 1.9 3.5 4.7 3.5 8.5 0 6.1-2.9 9.2-8.7 9.2zM81.7 147h11.2c1.9 0 2.9-1.3 2.9-3.8 0-1.8-.5-3-1.4-3.7-.9-.7-2.6-1.1-5.1-1.1-2.8 0-4.8.6-5.9 1.8-1.1 1.1-1.7 3.4-1.7 6.8zm46.8-14.1l.5 4.8c5-3.8 9.7-5.7 14.1-5.7 2.9 0 5.1.8 6.6 2.3 1.5 1.5 2.3 3.8 2.3 6.7v24.5h-8.1v-22c0-1.8-.2-3-.7-3.7-.5-.6-1.4-1-2.7-1-1.5 0-3 .3-4.6.9-1.6.6-3.6 1.6-6.1 3.1v22.7h-8.1v-32.6h6.8zm53.8 5.9v16.5c0 1.4.3 2.4.9 3 .6.6 1.6.8 3.1.8h4.5l.9 6c-2.3.8-5.1 1.1-8.4 1.1-2.8 0-5-.8-6.5-2.5-1.5-1.6-2.3-4-2.3-7v-17.9h-5.9v-5.5l5.8-.3v-9.4h8v9.4h9.6v5.8h-9.7zm46.7 13.8h-13.3c.3 2.8 1.1 4.7 2.4 5.7 1.3 1 3.4 1.4 6.3 1.4 3.3 0 7.2-.3 11.7-.8l.7 5.2c-3.1 1.5-7.5 2.2-13.4 2.2s-10.1-1.3-12.6-3.9c-2.5-2.6-3.7-7-3.7-13.2 0-6.3 1.2-10.8 3.7-13.3 2.4-2.5 6.5-3.8 12.1-3.8 5.2 0 8.9.9 11.3 2.8 2.3 1.9 3.5 4.7 3.5 8.5 0 6.1-2.9 9.2-8.7 9.2zm-13.4-5.6h11.2c1.9 0 2.9-1.3 2.9-3.8 0-1.8-.5-3-1.4-3.7-.9-.7-2.6-1.1-5.1-1.1-2.8 0-4.8.6-5.9 1.8-1 1.1-1.6 3.4-1.7 6.8zm62.1-15l-.9 7.6h-2.3c-2.3 0-5.9 1-10.8 2.9v23h-8.1v-32.6h6.3l.7 4.8c4.7-3.8 9.1-5.7 13.4-5.7h1.7z"/>
    </svg>
  )
}

export function DescHelp({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 200"
    >
      <path
        fill="#ffffff"
        fillRule="evenodd"
        d="M90.7 37.002v69.148H69.036V77.088H51.664v29.062H30V37.002h21.664v24.853h17.372V37.002H90.7zm61 52.913l.999 15.333c-6.656.869-18.603 1.303-35.841 1.303-4.726 0-8.603-1.453-11.631-4.36-3.029-2.906-4.543-6.697-4.543-11.374V52.335c0-4.677 1.514-8.468 4.543-11.374 3.028-2.907 6.905-4.36 11.63-4.36 17.24 0 29.186.435 35.842 1.303l-.999 15.333h-25.258c-1.265 0-2.263.334-2.995 1.002-.732.668-1.098 1.537-1.098 2.606v6.714h25.757v14.43H122.35v8.319c0 1.068.366 1.937 1.098 2.605.732.668 1.73 1.002 2.995 1.002H151.7zm30.45-52.913v48.303c0 1.07.383 1.938 1.149 2.606.765.668 1.78 1.002 3.045 1.002h23.162l.998 16.235c-6.855.935-18.07 1.403-33.645 1.403-4.925 0-8.885-1.453-11.88-4.36-2.995-2.906-4.493-6.697-4.493-11.374V37.002h21.665zm34.145 69.148V37.002C223.084 36.334 232.8 36 245.447 36c10.982 0 18.486 1.637 22.513 4.91 4.027 3.274 6.04 9.487 6.04 18.64 0 9.02-1.864 15.166-5.59 18.44-3.728 3.273-10.384 4.91-19.968 4.91-3.594 0-7.088-.2-10.483-.601v23.85h-21.664zm21.664-38.583h6.989c2.928 0 4.892-.534 5.89-1.603.998-1.069 1.498-3.207 1.498-6.414 0-3.273-.5-5.461-1.498-6.564-.998-1.102-2.962-1.653-5.89-1.653h-6.989v16.234zM69.855 160.386l.659 4.81C67.598 166.4 64.004 167 59.73 167c-5.231 0-8.925-1.162-11.082-3.487-2.156-2.325-3.234-6.334-3.234-12.026s1.088-9.7 3.264-12.026c2.177-2.325 5.88-3.487 11.112-3.487 4.113 0 7.528.56 10.243 1.683l-.838 4.57c-1.957-.08-4.673-.12-8.147-.12-3.035 0-5.131.661-6.29 1.984-1.158 1.323-1.737 3.788-1.737 7.396 0 3.648.58 6.143 1.737 7.486 1.159 1.343 3.255 2.014 6.29 2.014 3.195 0 6.13-.2 8.806-.601zm30.61-5.772h-11.98c.279 2.565.997 4.279 2.156 5.14 1.158.862 3.055 1.293 5.69 1.293 2.995 0 6.51-.24 10.543-.721l.659 4.69c-2.756 1.323-6.789 1.984-12.1 1.984-5.312 0-9.085-1.183-11.322-3.548-2.236-2.365-3.354-6.353-3.354-11.965 0-5.732 1.098-9.751 3.294-12.056 2.197-2.305 5.83-3.457 10.903-3.457 4.672 0 8.066.851 10.183 2.555 2.116 1.704 3.175 4.26 3.175 7.667 0 5.612-2.616 8.418-7.848 8.418zm-12.1-5.111h10.063c1.757 0 2.636-1.143 2.636-3.428 0-1.603-.42-2.726-1.258-3.367-.84-.641-2.357-.962-4.553-.962-2.556 0-4.323.531-5.301 1.593-.979 1.063-1.508 3.117-1.588 6.164zM127 136.815l.48 4.33c4.552-3.448 8.785-5.171 12.698-5.171 2.596 0 4.593.701 5.99 2.104 1.398 1.403 2.097 3.427 2.097 6.073v22.127h-7.308v-19.902c0-1.644-.22-2.756-.659-3.337-.44-.581-1.258-.872-2.456-.872-1.358 0-2.745.28-4.163.842-1.418.56-3.245 1.483-5.481 2.766v20.503h-7.308v-29.463h6.11zm44.986 5.292v14.972c0 1.283.26 2.174.779 2.676.52.5 1.438.751 2.755.751h4.014l.779 5.412c-2.117.681-4.633 1.022-7.548 1.022-2.556 0-4.523-.742-5.9-2.225-1.378-1.483-2.067-3.608-2.067-6.374v-16.234h-5.331v-4.99l5.271-.302v-8.478h7.248v8.478h8.626v5.292h-8.626zm38.577 12.507h-11.98c.28 2.565.998 4.279 2.156 5.14 1.158.862 3.055 1.293 5.69 1.293 2.996 0 6.51-.24 10.543-.721l.66 4.69c-2.756 1.323-6.79 1.984-12.1 1.984-5.312 0-9.086-1.183-11.322-3.548-2.237-2.365-3.355-6.353-3.355-11.965 0-5.732 1.098-9.751 3.295-12.056 2.196-2.305 5.83-3.457 10.902-3.457 4.672 0 8.067.851 10.183 2.555 2.117 1.704 3.175 4.26 3.175 7.667 0 5.612-2.616 8.418-7.847 8.418zm-12.1-5.111h10.063c1.757 0 2.636-1.143 2.636-3.428 0-1.603-.42-2.726-1.258-3.367-.839-.641-2.356-.962-4.552-.962-2.556 0-4.323.531-5.302 1.593-.978 1.063-1.507 3.117-1.587 6.164zm52.414-13.53l-.779 6.855h-2.096c-2.077 0-5.312.882-9.704 2.646v20.804h-7.308v-29.463h5.69l.66 4.33c4.192-3.448 8.226-5.171 12.1-5.171h1.437z"
      />
    </svg>
  )
}

export function DeliteIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
    >
      <path
        fill="#000"
        fillRule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0-5.586l-1.96 1.96c-.942.943-2.357-.472-1.414-1.414L6.586 8l-1.96-1.96c-.943-.942.472-2.357 1.414-1.414L8 6.586l1.96-1.96c.942-.943 2.357.472 1.414 1.414L9.414 8l1.96 1.96c.943.942-.472 2.357-1.414 1.414L8 9.414z"
      />
    </svg>
  )
}

export function AccountIdentifierIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
    >
      <path
        fill="#50B077"
        fillRule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm3.26-11.171a1 1 0 0 1 1.48 1.345l-5 5.5a1 1 0 0 1-1.447.035l-3-3a1 1 0 0 1 1.414-1.415l2.259 2.259 4.294-4.724z"
      />
    </svg>
  )
}

export function AccountWaitIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
    >
      <path
        fill="#BBB"
        fillRule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.75-4.75a.75.75 0 1 1-1.5 0V7.667a.75.75 0 0 1 .252-.56l3.44-3.17a.75.75 0 0 1 .996 1.122L8.75 8.003v3.247z"
      />
    </svg>
  )
}

export function AccountWarningIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
    >
      <path
        fill="#FFC356"
        fillRule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm-.728-7.238L7.06 5.537A24.39 24.39 0 0 1 7 4.185c0-.373.096-.663.288-.872.192-.209.445-.313.758-.313.38 0 .634.133.762.4S9 4.052 9 4.555c0 .296-.015.597-.046.902l-.285 3.318c-.031.395-.097.698-.199.909a.52.52 0 0 1-.503.316c-.239 0-.404-.102-.497-.306-.093-.204-.159-.515-.198-.932zM8.007 13c-.27 0-.505-.088-.706-.264-.2-.176-.301-.423-.301-.74 0-.276.096-.511.288-.705A.954.954 0 0 1 7.993 11c.279 0 .516.097.712.291.197.194.295.43.295.706 0 .312-.1.557-.298.735-.199.179-.43.268-.695.268z"
      />
    </svg>
  )
}

export function AccountAlertIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
    >
      <path
        fill="#FF4E44"
        fillRule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm-.728-7.238L7.06 5.537A24.39 24.39 0 0 1 7 4.185c0-.373.096-.663.288-.872.192-.209.445-.313.758-.313.38 0 .634.133.762.4S9 4.052 9 4.555c0 .296-.015.597-.046.902l-.285 3.318c-.031.395-.097.698-.199.909a.52.52 0 0 1-.503.316c-.239 0-.404-.102-.497-.306-.093-.204-.159-.515-.198-.932zM8.007 13c-.27 0-.505-.088-.706-.264-.2-.176-.301-.423-.301-.74 0-.276.096-.511.288-.705A.954.954 0 0 1 7.993 11c.279 0 .516.097.712.291.197.194.295.43.295.706 0 .312-.1.557-.298.735-.199.179-.43.268-.695.268z"
      />
    </svg>
  )
}

export function DataIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M6 10h4V6H6v4zm0 1v4h4v-4H6zm9-1V6h-4v4h4zm0 1h-4v4h3a1 1 0 0 0 1-1v-3zM1 10h4V6H1v4zm0 1v3a1 1 0 0 0 1 1h3v-4H1zm5-6h4V1H6v4zm9 0V2a1 1 0 0 0-1-1h-3v4h4zM1 5h4V1H2a1 1 0 0 0-1 1v3zm1-5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm1 3.354l-.823.823c-.236.235-.59-.118-.354-.354L2.646 3l-.823-.823c-.235-.236.118-.59.354-.354L3 2.646l.823-.823c.236-.235.59.118.354.354L3.354 3l.823.823c.235.236-.118.59-.354.354L3 3.354zm5 0l-.823.823c-.236.235-.59-.118-.354-.354L7.646 3l-.823-.823c-.235-.236.118-.59.354-.354L8 2.646l.823-.823c.236-.235.59.118.354.354L8.354 3l.823.823c.235.236-.118.59-.354.354L8 3.354zm5 0l-.823.823c-.236.235-.59-.118-.354-.354L12.646 3l-.823-.823c-.235-.236.118-.59.354-.354l.823.823.823-.823c.236-.235.59.118.354.354L13.354 3l.823.823c.235.236-.118.59-.354.354L13 3.354zm-10 5l-.823.823c-.236.235-.59-.118-.354-.354L2.646 8l-.823-.823c-.235-.236.118-.59.354-.354L3 7.646l.823-.823c.236-.235.59.118.354.354L3.354 8l.823.823c.235.236-.118.59-.354.354L3 8.354zm0 5l-.823.823c-.236.235-.59-.118-.354-.354L2.646 13l-.823-.823c-.235-.236.118-.59.354-.354l.823.823.823-.823c.236-.235.59.118.354.354L3.354 13l.823.823c.235.236-.118.59-.354.354L3 13.354z"
      />
    </svg>
  )
}

export function GaMenu({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={24}
      viewBox="0 0 22 24"
    >
      <path
        fillRule="nonzero"
        d="M16 2.864C16 1.272 17.429 0 19 0s3 1.154 3 3v17.864C22 23.045 20.429 24 19 24c-1.544 0-3-1.122-3-3.136v-18zm-8.12 9.002C7.88 10.273 9.313 9 10.89 9c1.576 0 3.009 1.154 3.009 3.002v8.733c0 2.184-1.576 3.139-3.01 3.139-1.548 0-3.008-1.123-3.008-3.139v-8.87zM3.01 23.874C1.347 23.874 0 22.59 0 21.008c0-1.582 1.347-2.865 3.009-2.865 1.661 0 3.009 1.283 3.009 2.865 0 1.583-1.348 2.866-3.01 2.866z"
      />
    </svg>
  )
}

export function DashBoardMenu({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M20.24 3.276C15.065 7.76 12.325 10 12.02 10c-.567 0-1.045.192-1.435.575-.39.384-.585.856-.585 1.418 0 .634.202 1.126.605 1.479.403.352.875.528 1.415.528a2.01 2.01 0 0 0 1.382-.535c.399-.357.598-.847.598-1.472 0-.307 2.242-3.05 6.725-8.231A11.959 11.959 0 0 1 24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0c3.19 0 6.09 1.245 8.24 3.276zM12.01 4c.261 0 .492-.09.691-.268.2-.178.299-.423.299-.735a.967.967 0 0 0-.286-.71A.954.954 0 0 0 12.01 2a.984.984 0 0 0-.718.288.955.955 0 0 0-.292.709c0 .316.1.563.302.739.202.176.438.264.708.264zm9 9c.261 0 .492-.09.691-.268.2-.178.299-.423.299-.735a.967.967 0 0 0-.286-.71.954.954 0 0 0-.704-.287.984.984 0 0 0-.718.288.955.955 0 0 0-.292.709c0 .316.1.563.302.739.202.176.438.264.708.264zm-18 0c.261 0 .492-.09.691-.268.2-.178.299-.423.299-.735a.967.967 0 0 0-.286-.71A.954.954 0 0 0 3.01 11a.984.984 0 0 0-.718.288.955.955 0 0 0-.292.709c0 .316.1.563.302.739.202.176.438.264.708.264zm3 6c.261 0 .492-.09.691-.268.2-.178.299-.423.299-.735a.967.967 0 0 0-.286-.71A.954.954 0 0 0 6.01 17a.984.984 0 0 0-.718.288.955.955 0 0 0-.292.709c0 .316.1.563.302.739.202.176.438.264.708.264zm12 0c.261 0 .492-.09.691-.268.2-.178.299-.423.299-.735a.967.967 0 0 0-.286-.71.954.954 0 0 0-.704-.287.984.984 0 0 0-.718.288.955.955 0 0 0-.292.709c0 .316.1.563.302.739.202.176.438.264.708.264zm-12-12c.261 0 .492-.09.691-.268.2-.178.299-.423.299-.735a.967.967 0 0 0-.286-.71A.954.954 0 0 0 6.01 5a.984.984 0 0 0-.718.288.955.955 0 0 0-.292.709c0 .316.1.563.302.739.202.176.438.264.708.264z"
      />
    </svg>
  )
}

export function ChanelsMenu({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M4 23a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm8 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm8 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM4 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm14.94 5.907a.75.75 0 0 1 .003-1.5l2.5.005a.75.75 0 0 1 .749.752l-.006 2.5a.75.75 0 0 1-1.5-.003l.001-.675a7.253 7.253 0 0 1-11.682-6.01.75.75 0 1 1 1.499.055 5.753 5.753 0 0 0 9.12 4.877l-.684-.001zM13.56 3.594a.75.75 0 0 1-.003 1.5l-2.5-.005a.75.75 0 0 1-.749-.752l.006-2.5a.75.75 0 0 1 1.5.003l-.002.674a7.253 7.253 0 0 1 11.68 6.097.75.75 0 1 1-1.5-.073 5.753 5.753 0 0 0-9.118-4.945l.686.001z"
      />
    </svg>
  )
}

export function ChanelsManualMenu({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M4 23a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm8 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm8 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM4 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm16.504-1.407L19.5 4.589a.55.55 0 1 0-.778.778l1.004 1.004-6.113 6.112c-.62.706-1.301.689-2.042-.05-.743-.745-.76-1.425-.054-2.046L19.5 2.5l2 2-.996 1.093zM9.839 14.984a.694.694 0 0 1-.824-.823l.807-3.766a.559.559 0 0 1 .01-.041c.029-.117.121-.231.213-.322l8.828-8.829c.271-.27.71-.27.981 0l2.943 2.943c.27.27.27.71 0 .98l-8.829 8.83c-.091.09-.205.183-.322.213a.559.559 0 0 1-.04.008l-3.767.807z"
      />
    </svg>
  )
}

export function BackIcon({className, width, height, stroke}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 12l8-8-8 8 8 8-8-8zm18 0H3h18z"
      />
    </svg>
  )
}

export function SearchIcon({className, width, height, stroke}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M16 16l6 6-6-6zm-6 2a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
      />
    </svg>
  )
}

export function ShopModule({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 80 72"
    >
      <g fill="#000" fillRule="evenodd">
        <path
          fillRule="nonzero"
          d="M22.25 35A21.901 21.901 0 0 1 18 22C18 9.85 27.85 0 40 0s22 9.85 22 22c0 4.863-1.578 9.358-4.25 13h-5.3A17.948 17.948 0 0 0 58 22c0-9.941-8.059-18-18-18s-18 8.059-18 18c0 5.11 2.13 9.724 5.55 13h-5.3zm8.42 0C26.63 32.096 24 27.355 24 22c0-8.837 7.163-16 16-16s16 7.163 16 16c0 5.355-2.63 10.096-6.67 13h-1.842C51.978 32.408 55 27.557 55 22c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 5.557 3.022 10.408 7.512 13H30.67z"
        />
        <path
          fillRule="nonzero"
          d="M40.72 23.365v3.213c1.358-.117 2.032-.713 2.032-1.582 0-.83-.518-1.25-2.031-1.63zm-1.122-2.92V17.33c-1.23.137-1.875.752-1.875 1.514 0 .761.566 1.25 1.875 1.601zm1.123.254l.693.156c2.666.596 4.063 1.68 4.063 3.829 0 2.46-1.983 3.964-4.756 4.16v1.543h-1.123v-1.533c-2.744-.166-4.727-1.612-4.805-4.053h2.617c.166.967.86 1.64 2.188 1.777v-3.467l-.655-.146c-2.548-.576-3.955-1.729-3.955-3.858 0-2.343 1.924-3.877 4.61-4.043v-1.572h1.123v1.572c2.715.206 4.482 1.739 4.57 4.063h-2.607c-.137-1.035-.87-1.63-1.963-1.787v3.36z"
        />
        <path
          fillRule="nonzero"
          d="M49.92 59l1.6 10H55a1.5 1.5 0 0 1 0 3H25a1.5 1.5 0 0 1 0-3h3.48l1.6-10H4a4 4 0 0 1-4-4V13a4 4 0 0 1 4-4h14.642a24.949 24.949 0 0 0-1.098 2H4a2 2 0 0 0-2 2v42a2 2 0 0 0 2 2h72a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2H62.456a24.949 24.949 0 0 0-1.098-2H76a4 4 0 0 1 4 4v42a4 4 0 0 1-4 4H49.92zm-2.025 0h-15.79l-1.6 10h18.99l-1.6-10z"
        />
        <path
          d="M7 53a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-18 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-48 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-18 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-48 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-18 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM25 32v3h30v-3h6a3 3 0 0 1 0 6H19a3 3 0 0 1 0-6h6z"/>
      </g>
    </svg>
  )
}

export function EcomMenu({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M6 23a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-1.715-8.16c.607.457 1.26.819 1.94 1.087L7.25 17.742a1 1 0 0 1-1.206-.554L2 8H1a1 1 0 1 1 0-2h2.2l1.3 3.5h3.595a8.236 8.236 0 0 0 3.19 5.34zm.382-5.34H15a1 1 0 0 1 1 1v2.494a4.741 4.741 0 0 1-2.608-.95A4.737 4.737 0 0 1 11.667 9.5zm7.273 3.407a.75.75 0 0 1 .003-1.5l2.5.005a.75.75 0 0 1 .749.752l-.006 2.5a.75.75 0 0 1-1.5-.003l.001-.675a7.253 7.253 0 0 1-11.682-6.01.75.75 0 1 1 1.499.055 5.753 5.753 0 0 0 9.12 4.877l-.684-.001zM13.56 3.594a.75.75 0 0 1-.003 1.5l-2.5-.005a.75.75 0 0 1-.749-.752l.006-2.5a.75.75 0 0 1 1.5.003l-.002.674a7.253 7.253 0 0 1 11.68 6.097.75.75 0 1 1-1.5-.073 5.753 5.753 0 0 0-9.118-4.945l.686.001z"
      />
    </svg>
  )
}

export function AmoCrmBigIcon({width, height}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 200 44"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#C6C7C9"
          d="M60.637 33.215c-.236-.9-.347-1.86-.335-2.883-.033-3.983 1.222-7.414 3.766-10.293 2.544-2.878 5.875-4.317 9.991-4.317 1.875 0 3.38.234 4.52.703 1.974.802 2.962 1.555 2.962 2.258 0 .536-1.382.813-4.142.83-2.762.016-5.072.97-6.93 2.86-1.857 1.892-2.787 4.277-2.787 7.157 0 1.505.444 2.768 1.331 3.79.887 1.022 2.143 1.531 3.766 1.531 1.623 0 2.97-.334 4.042-1.005-2.378-1.606-3.566-3.932-3.566-6.979-.033-1.606.545-3.07 1.733-4.392 1.188-1.322 2.711-1.992 4.57-2.009 1.856-.016 3.187.494 3.99 1.532.804 1.037 1.206 2.368 1.206 3.991 0 1.624-.385 3.34-1.155 5.148h.301c1.473-.035 2.744-.553 3.816-1.559.402-.401.744-.753 1.03-1.053.283-.301.578-.452.878-.452.469 0 .703.553.703 1.656 0 2.043-.602 3.574-1.807 4.594-1.205 1.022-2.536 1.532-3.992 1.532s-2.686-.1-3.69-.3c-2.645 3.113-5.817 4.669-9.515 4.669-3.7 0-6.47-.947-8.31-2.838a10.342 10.342 0 0 1-.245-.26c-2.208 1.897-4.554 2.846-7.035 2.846-2.41 0-3.615-2.192-3.615-6.577 0-1.105.183-2.628.552-4.57.368-1.94.553-3.363.553-4.268 0-1.103-.636-1.656-1.908-1.656-.87 0-1.841.846-2.912 2.536a17.96 17.96 0 0 0-2.31 5.448v.1c0 1.139.175 2.31.526 3.515.352 1.205.528 2.042.528 2.51 0 1.138-1.423 2.26-4.268 3.364-.435.167-.82.252-1.154.252-.837 0-1.415-.437-1.733-1.306-.318-.87-.477-2.05-.477-3.54 0-1.49.042-2.895.126-4.217.083-1.322.167-2.543.251-3.666.084-1.121.167-2.109.25-2.962a22.29 22.29 0 0 0 .127-2.084c0-1.137-.52-1.707-1.557-1.707-1.038 0-2.243 1.213-3.615 3.64-1.373 2.428-2.059 4.352-2.059 5.773 0 1.425.176 2.738.528 3.943.351 1.205.527 2.042.527 2.51 0 1.138-1.424 2.26-4.268 3.364-.435.167-.82.252-1.155.252-.837 0-1.414-.437-1.732-1.306-.147-.402-.26-.904-.34-1.507-.677.455-1.392.858-2.145 1.206-1.372.636-2.711.953-4.016.953-1.775 0-2.962-1.556-3.565-4.67a10.964 10.964 0 0 1-3.415 3.54c-1.405.922-3.288 1.382-5.648 1.382s-4.26-.736-5.699-2.21C.67 36.542-.032 34.75.001 32.64c0-5.688 1.89-10.174 5.674-13.456 1.608-1.371 3.105-2.275 4.494-2.71a14.612 14.612 0 0 1 4.393-.654c1.54 0 2.795.269 3.766.804.468-.97 1.004-1.456 1.606-1.456 1.172 0 2.285.51 3.34 1.532 1.054 1.021 1.582 1.982 1.582 2.886-.47 1.105-1.156 2.427-2.06 3.967-.267 1.54-.402 3.699-.402 6.477 0 2.78.352 4.167 1.055 4.167.54 0 1.553-.667 3.042-2.002.066-3.173.24-5.568.522-7.186.502-3.114 1.64-6.058 3.415-8.838.602-.936 1.255-1.405 1.958-1.405 1.104 0 2.125.904 3.063 2.712.267.47.467.904.602 1.305 1.607-2.008 3.497-3.013 5.674-3.013 1.438 0 2.728.477 3.866 1.432 1.137.954 1.707 2.15 1.707 3.589v.552c2.04-2.543 4.535-3.815 7.48-3.815 1.809 0 3.181.469 4.117 1.406.938.936 1.407 2.092 1.407 3.464 0 1.373-.1 2.611-.301 3.717a44.358 44.358 0 0 1-.678 3.112c-.251.97-.477 1.831-.678 2.585-.2.754-.302 1.34-.302 1.757 0 .42.134.628.403.628.5 0 1.12-.318 1.857-.954l.034-.029zm-53.255-2.23c0 2.578.955 3.866 2.862 3.866 2.041-.032 3.732-1.121 5.071-3.263.469-.736.854-1.64 1.155-2.712 0-3.749.335-6.961 1.005-9.64-2.712.536-5.072 1.841-7.08 3.916-2.009 2.076-3.013 4.688-3.013 7.832zm73.004-1.256c.569-1.204.854-2.376.854-3.514s-.37-1.707-1.105-1.707c-.302 0-.553.218-.753.653-.201.435-.302.853-.302 1.255 0 1.34.435 2.444 1.306 3.313z"
        />
        <path
          fill="#87D5F6"
          d="M199.593 35.2a5.025 5.025 0 1 1-10.05-.002 5.025 5.025 0 0 1 10.05.001zm-89.147.946c-1.321 1.305-2.907 2.448-4.76 3.425-2.304 1.218-5.017 1.826-8.14 1.826-3.127 0-5.862-1.042-8.21-3.133-2.35-2.09-3.524-5.106-3.524-9.047 0-3.938.55-7.51 1.655-10.71 1.104-3.2 2.56-5.963 4.37-8.29 1.808-2.328 3.864-4.14 6.167-5.436 2.302-1.295 4.485-1.944 6.553-1.944 3.618 0 5.427 1.615 5.427 4.84 0 1.853-.34 3.332-1.02 4.443-.684 1.11-1.376 1.666-2.08 1.666-.942 0-1.762-.37-2.466-1.112-.707-.739-1.481-1.123-2.327-1.149-.847-.026-3.144-.09-5.097 3.049-1.365 2.193-1.155 1.97-1.673 3.452-1.033 2.963-1.639 5.237-1.639 9.204.047 1.905 1.75 4.817 3.254 5.77 1.032.633 2.265 1.166 3.665.99 3.02-.38 4.714-1.811 5.948-3.133 1.139-1.221 2.142-2.379 3.224-3.624a83.637 83.637 0 0 0 2.855-3.45c.148-.19.29-.364.424-.52 1.4-4.37 2.854-7.742 4.368-10.12.333-.501.818-1.02 1.456-1.555.636-.536 1.322-.804 2.057-.804.436 0 .654.57.654 1.707 0 1.138-.069 2.21-.2 3.214a46.678 46.678 0 0 1-1.156 5.422c-1.205 4.552-1.808 7.213-1.808 7.983v7.38c0 1.808-.686 3.047-2.058 3.718-.637.3-1.247.585-1.833.852-.586.268-1.248.403-1.983.403-1.405 0-2.108-1.615-2.108-4.846 0-.155.001-.312.005-.471zm28.91 1.732a15.372 15.372 0 0 1-3.259 2.027c-1.373.637-2.678.954-3.916.954s-2.209-.233-2.912-.702c-.703-.47-1.255-1.105-1.658-1.908-.568-1.138-1.037-3.306-1.405-6.503-.37-3.195-.737-5.43-1.105-6.702a5.173 5.173 0 0 1-2.285-1.03c-.652-.519-.979-1.155-.979-1.908 0-.753.343-1.298 1.03-1.632.685-.333 1.472-.502 2.36-.502.886 0 1.682.218 2.384.653a9.461 9.461 0 0 0 2.286-2.737c.585-1.054.877-2.476.877-4.267 0-1.79-.601-3.222-1.807-4.293-1.205-1.072-2.97-1.607-5.297-1.607-2.326 0-4.11.185-5.347.553-1.239.368-2.302.77-3.189 1.205a73.54 73.54 0 0 0-2.36 1.205c-.686.368-1.33.552-1.932.552-.602 0-.904-.192-.904-.577 0-.384.318-1.012.954-1.883.636-.87 1.574-1.74 2.812-2.612 3.112-2.175 6.628-3.254 10.544-3.238 3.916.017 7.146.763 9.69 2.235.74.432 1.389.919 1.945 1.458.422-.652 1.012-1.239 1.77-1.76 1.64-1.205 3.633-1.807 5.974-1.807 3.013 0 4.787 1.406 5.324 4.218.132.836.233 1.723.3 2.66 2.476-4.651 5.606-6.978 9.39-6.978 4.117 0 6.477 1.975 7.08 5.924.201 1.138.285 2.36.25 3.666v.4c2.176-3.012 4.753-4.518 7.733-4.518 4.218 0 6.326 2.544 6.326 7.632 0 2.21-.343 4.795-1.029 7.757a534.917 534.917 0 0 1-1.505 6.377c-.32 1.288-.477 2.285-.477 2.988 0 1.272.442 1.907 1.33 1.907.886 0 3.004-1.74 6.35-5.222.604-.669 1.04-1.003 1.307-1.003.57 0 .854.77.854 2.31 0 .836-.352 1.85-1.055 3.038-.703 1.188-1.615 2.276-2.736 3.262-1.123.989-2.37 1.8-3.74 2.435a10.192 10.192 0 0 1-4.344.955c-1.523 0-2.711-.494-3.565-1.482-.854-.986-1.28-2.092-1.28-3.314 0-1.221.2-2.602.603-4.142.401-1.54.836-3.146 1.305-4.82 1.272-4.45 1.924-7.581 1.958-9.389 0-.77-.101-1.364-.302-1.783-.2-.419-.585-.628-1.154-.628-1.005 0-2.076.604-3.213 1.808-1.14 1.206-2.21 2.745-3.214 4.619-2.31 4.285-3.531 8.47-3.666 12.553l.202 1.406c.067.47.1.97.1 1.505 0 1.072-.527 2.052-1.581 2.94-1.055.885-2.235 1.33-3.54 1.33-.77 0-1.339-.378-1.708-1.131-.37-.752-.553-1.682-.553-2.785 0-1.105.25-2.612.754-4.52a381.229 381.229 0 0 1 1.657-6.076c1.606-5.656 2.427-9.874 2.46-12.652 0-1.407-.175-2.51-.526-3.315-.352-.802-1.03-1.204-2.034-1.204-1.807 0-3.6 1.289-5.374 3.866-1.775 2.578-3.363 6.578-4.77 12a59.847 59.847 0 0 0-.853 3.665l-.051.954c.636 3.08.954 5.088.954 6.026 0 1.942-.687 3.246-2.057 3.917-.638.3-1.25.585-1.835.852a4.47 4.47 0 0 1-1.883.403c-1.447 0-2.268-1.196-2.464-3.585zm-1.426-28.02c.318.952.477 1.997.477 3.135.033 2.88-.72 5.272-2.26 7.18-1.54 1.908-3.447 3.281-5.724 4.117a20.737 20.737 0 0 1 1.231 3.564c.316 1.273.628 2.446.928 3.516.302 1.072.644 1.958 1.03 2.661.383.703.853 1.054 1.405 1.054s1.223-.325 2.009-.979a34.102 34.102 0 0 0 2.334-2.133l.342-.344c.42-3.413 1.177-7.985 2.27-13.716.634-3.346.953-5.22.953-5.622 0-2.713-.687-4.067-2.058-4.067-.47 0-.896.133-1.282.401a24.9 24.9 0 0 0-1.154.854c-.166.13-.333.256-.501.38z"
        />
      </g>
    </svg>
  )
}

export function Bitrix24BigIcon({width, height}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 200 44"
    >
      <g fill="none" fillRule="nonzero">
        <path
          fill="#005893"
          d="M135.834 30.377h17.961v-4.05h-11.838c1.633-6.646 11.634-8.1 11.634-15.473 0-3.946-2.653-6.854-8.266-6.854-3.47 0-6.532 1.038-8.573 2.077l1.225 3.738c1.837-.934 3.98-1.765 6.633-1.765 2.041 0 3.98.935 3.98 3.323 0 5.4-11.736 5.815-12.756 19.004zm18.471-6.439h11.532v6.439h4.593v-6.439h3.878v-3.946h-3.878V4h-3.368l-12.757 16.823v3.115zm5.205-3.738l6.532-8.93c0 .726-.205 3.01-.205 5.088v3.738h-3.061c-.919 0-2.654.104-3.266.104z"
        />
        <path
          fill="#0BBBEF"
          d="M4.82 26.217v-8.126h1.95c1.743 0 3.179.206 4.204.823 1.026.617 1.641 1.646 1.641 3.292 0 2.777-1.64 4.011-5.538 4.011H4.82zM.104 30.126h6.871c7.693 0 10.462-3.395 10.462-8.126 0-3.189-1.333-5.349-3.692-6.583-1.847-1.028-4.206-1.337-7.077-1.337H4.82V7.909h10.358l1.231-3.806H0v26.023h.103zm20.512 0h4.513l5.846-8.435c1.129-1.542 1.95-3.085 2.462-3.908h.102a45.38 45.38 0 0 0-.205 4.011v8.229h4.616V11.509h-4.513l-5.846 8.434c-1.026 1.543-1.949 3.086-2.462 3.908h-.102a45.38 45.38 0 0 0 .205-4.011v-8.229h-4.616v18.515zm25.231 0h4.718V15.417h5.539l1.23-3.908H40.205v3.908h5.641v14.709zm13.128 9.36h4.616v-9.36c.923.308 1.846.411 2.872.411 5.846 0 9.64-4.011 9.64-9.771 0-5.966-3.487-9.772-10.153-9.772-2.564 0-5.026.515-7.077 1.132v27.36h.102zm4.616-13.372V15.211a7.27 7.27 0 0 1 2.154-.308c3.384 0 5.538 1.851 5.538 5.863 0 3.6-1.744 5.863-5.23 5.863-.924 0-1.642-.206-2.462-.515zm15.282 4.012h4.513l5.846-8.435c1.128-1.542 1.948-3.085 2.461-3.908h.103a45.38 45.38 0 0 0-.205 4.011v8.229h4.615V11.509h-4.513l-5.846 8.434c-1.025 1.543-1.949 3.086-2.461 3.908h-.103a45.38 45.38 0 0 0 .205-4.011v-8.229h-4.615v18.515zm21.025 0h4.718V22.41h2.77c.512 0 1.025.515 1.64 1.749l2.36 5.966h5.025l-3.384-7.097c-.616-1.235-1.231-1.955-2.154-2.263v-.103c1.538-.926 1.743-3.6 2.666-4.937.308-.412.718-.617 1.334-.617.307 0 .718 0 1.025.205v-4.011c-.512-.206-1.435-.309-1.948-.309-1.641 0-2.667.617-3.385 1.646-1.538 2.263-1.538 6.171-3.795 6.171h-2.154V11.51h-4.718v18.617zm26.975.411c2.564 0 4.923-.823 6.359-1.851l-1.334-3.189c-1.333.72-2.564 1.234-4.307 1.234-3.18 0-5.231-2.057-5.231-5.862 0-3.395 2.051-6.069 5.538-6.069 1.847 0 3.18.514 4.513 1.44v-4.011c-1.025-.618-2.666-1.235-5.025-1.235-5.539 0-9.847 4.115-9.847 9.977 0 5.349 3.283 9.566 9.334 9.566z"
        />
        <path
          fill="#005893"
          d="M189.657 25.089c5.66 0 10.277-4.627 10.277-10.3 0-5.672-4.617-10.299-10.277-10.299-5.66 0-10.276 4.627-10.276 10.3.116 5.715 4.654 10.299 10.276 10.299zm0-1.862c-4.598 0-8.323-3.762-8.419-8.457 0-4.624 3.786-8.418 8.42-8.418 4.633 0 8.418 3.794 8.418 8.437 0 4.644-3.785 8.438-8.419 8.438z"
        />
        <path fill="#005893" d="M195.721 14.3h-4.875V9.4h-1.294v6.2h6.17z"/>
      </g>
    </svg>
  )
}

export function BitrixBigIcon({width, height}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 200 44"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#231F20"
          d="M78.626 20.536a2.873 2.873 0 0 0-2.878 2.865 2.872 2.872 0 0 0 2.878 2.867 2.871 2.871 0 0 0 2.878-2.867 2.871 2.871 0 0 0-2.878-2.865zm117.1-2.103c1.886 0 3.266 1.052 4.17 2.103v-5.08c-1.482-1-3.267-1.401-4.82-1.401-4.77 0-8.916 3.402-8.916 9.256 0 5.605 3.767 9.259 8.99 9.259 1.506 0 3.163-.227 4.747-1.301v-4.983c-.905.928-2.334 1.905-4.172 1.905-2.81 0-4.494-2.076-4.494-4.73 0-2.877 1.783-5.028 4.494-5.028zm-9.026-3.877h-5.777l-5.3 7.355v-7.355h-4.921l.002 17.513h4.92v-7.532l5.096 7.532h6.156l-6.857-9.033 6.68-8.48zm-30.533 10.508V14.556h-4.746v17.513h4.822l6.806-10.509v10.51h4.746V14.555h-4.823l-6.805 10.508zm-14.263-2.629H140.5V18.41h1.404c2.11 0 2.41 1.125 2.41 2.001 0 .75-.225 2.025-2.41 2.025zm1.08-7.88h-7.408V32.07h4.924v-5.783h2.483c4.974 0 6.406-3.448 6.406-5.876 0-2.403-1.407-5.854-6.406-5.854zm-22.073 4.202h3.865V32.07h4.924V18.757h3.866v-4.201h-12.655v4.201zm-13.639 6.307V14.556h-4.745v17.513h4.823l6.803-10.509v10.51h4.747V14.555h-4.82l-6.808 10.508zm-14.665 3.5h-2.109v-3.676h2.109c1.558 0 2.462.45 2.462 1.828 0 1.4-.929 1.848-2.462 1.848zm.478-7.179h-2.587v-2.628h8.061v-4.201H85.577l-.001 17.513h7.51c1.278 0 6.905.049 6.905-5.429 0-5.28-5.575-5.255-6.906-5.255zm-35.058 1.926c0 5.605 3.767 9.259 8.99 9.259 1.509 0 3.166-.227 4.748-1.301v-4.983c-.907.928-2.338 1.905-4.17 1.905-2.814 0-4.495-2.076-4.495-4.73 0-2.877 1.782-5.028 4.495-5.028 1.883 0 3.263 1.052 4.17 2.103v-5.08c-1.485-1-3.266-1.401-4.823-1.401-4.772 0-8.915 3.402-8.915 9.256zm-10.305-4.727h2.688v13.485h4.546V14.556h-7.234v4.028z"
        />
        <path
          fill="#D91935"
          d="M19.502 2c-1.453 0-2.866.163-4.228.465v19.05a4.246 4.246 0 0 0 4.239 4.239 4.245 4.245 0 0 0 4.237-4.238 4.247 4.247 0 0 0-3.955-4.23v-3.391c4.07.147 7.345 3.515 7.345 7.621 0 4.2-3.426 7.629-7.627 7.629-4.203 0-7.629-3.428-7.629-7.63V3.544c-.481.204-.952.43-1.413.674v17.297c0 4.98 4.063 9.04 9.042 9.04 4.98 0 9.04-4.06 9.04-9.039 0-4.884-3.908-8.885-8.758-9.036V9.09c6.717.151 12.147 5.675 12.147 12.426 0 6.847-5.584 12.43-12.43 12.43S7.08 28.363 7.08 21.516V6.466C2.757 10.043 0 15.45 0 21.501c0 10.77 8.731 19.503 19.502 19.503 10.773 0 19.502-8.733 19.502-19.503S30.275 2 19.502 2"
        />
      </g>
    </svg>
  )
}

export function RetailCrmBigIcon({width, height}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 200 44"
    >
      <defs>
        <path id="a" d="M0 0h200v43.154H0z"/>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a"/>
        </mask>
        <path
          fill="#EE3433"
          fillRule="nonzero"
          d="M99.725 13.89c2.403 0 4.806.805 6.408 2.415l3.404-3.22c-2.804-2.618-6.208-4.027-9.812-4.027-9.813 0-14.218 7.046-14.218 13.89s4.205 13.688 14.218 13.688c3.804 0 7.409-1.208 10.212-3.825l-3.404-3.422c-1.802 1.812-4.405 2.617-6.808 2.617-6.609 0-9.212-4.63-9.212-8.857 0-4.63 2.804-9.26 9.212-9.26zm44.655 4.428c0-4.63-3.404-8.656-9.612-8.656h-12.816v26.37h5.007v-8.857h4.806l7.81 8.857h6.007v-.402l-8.21-9.059c5.406-1.006 7.008-4.63 7.008-8.253zm-17.421 4.429v-8.455h7.81c3.203 0 4.605 2.013 4.605 4.227 0 2.013-1.402 4.228-4.606 4.228h-7.81zM13.417 17.312v-.202c-.2-.402-.4-.402-.801-.604-.801-.2-1.602-.402-2.603-.402-1.202 0-2.203.201-3.204.604-.801.402-1.202.805-2.003 1.61v-2.013H0v19.727h5.006V24.156c0-2.215 1.402-3.624 3.405-3.624.8 0 1.401.202 2.202.805h.2c.401-1.61 1.402-3.019 2.604-4.025zm36.245-1.208c-3.204 0-5.407.604-5.807.805l-.2.201c.4 1.61 1.401 3.221 2.002 4.026 0 .201.2.201.4 0 1.402-.805 2.203-.805 3.805-.805 2.604 0 3.805.805 3.805 3.02v1.006h-4.806c-4.205 0-6.808 2.214-6.808 5.838 0 3.824 2.603 6.038 6.808 6.038 1.202 0 2.003-.2 2.804-.402.8-.201 1.201-.604 2.002-1.41v1.611h4.806V23.15c.4-4.63-2.403-7.045-8.81-7.045zm4.205 12.681c0 2.416-1 3.423-3.604 3.423-2.203 0-3.204-.806-3.204-2.215 0-1.409 1.001-2.214 2.803-2.214h4.005v1.006zM40.25 32.006c0-.201-.2-.201-.2-.201h-.8c-1.202 0-1.803-.604-1.803-1.812v-9.46h5.006c.2 0 .2-.202.2-.202-.8-1.61-1.201-3.02-1.401-3.422 0 0 0-.201-.2-.201h-3.605V11.07H32.44v5.838h-3.605c-.2 0-.2.201-.2.201.4.604 1.402 1.812 1.802 3.422 0 0 0 .202.2.202h1.803v9.863c0 3.422 2.403 5.636 5.807 5.636 1.802 0 3.204-.402 3.604-.603.2 0 .2-.202 0-.403-.2-.403-1.201-1.61-1.602-3.22zM20.826 16.104c-5.407 0-8.811 3.824-8.811 10.065 0 6.642 3.204 10.064 9.412 10.064 1.602 0 3.004-.2 4.205-.805 1.202-.604 2.003-1.006 3.404-2.214v-.201l-3.003-2.617h-.2c-.802.805-1.202 1.006-2.003 1.409-.601.201-1.602.403-2.403.403-3.004 0-4.406-1.41-4.606-4.429h12.015c.4 0 .6-.201.6-.604v-1.61c.201-5.637-3.203-9.461-8.61-9.461zm-3.805 8.253c.2-2.617 1.602-4.227 3.805-4.227 2.403 0 3.605 1.409 3.805 4.227h-7.61zm44.656 11.675h5.006V16.305h-5.006v19.727zM64.08 7.65c-1.802 0-3.204 1.41-3.204 3.02s1.402 3.02 3.204 3.02c1.802 0 3.204-1.41 3.204-3.222 0-1.409-1.402-2.818-3.204-2.818zm5.607 28.383h5.006V9.058h-5.006v26.974zm37.247 2.818a.444.444 0 0 0-.601.604l1.201 1.41c-2.603 1.006-5.206 1.61-8.01 1.61-11.013 0-20.025-8.857-20.025-19.526S88.511 3.422 99.524 3.422c2.604 0 5.207.604 7.61 1.41.2 0 .6 0 .6-.202.2-.201 0-.604-.2-.604-2.603-1.007-5.206-1.61-8.01-1.61-11.614 0-21.026 9.26-21.026 20.532S87.91 43.48 99.524 43.48c2.804 0 5.607-.604 8.41-1.61l.201 1.811c.2.403.6.403.801 0l1.001-2.818c0-.201 0-.402-.2-.604l-2.803-1.409zm47.259-18.519c-.2-.201-.801-.201-.801.201l.4 1.812h-3.604s-.2 0-.2-.201V4.83c0-.604-.401-1.006-1.002-1.006h-2.203s-.2 0-.2-.202V1.208c0-.202.2-.403.4-.403h24.231c.2 0 .4.201.4.403v11.876l-1.802-.402c-.4 0-.6.402-.4.805l2.203 2.013c.2.201.4.201.6 0l2.203-2.013c.2-.201.2-.805-.4-.805l-1.803.402V1.006c0-.603-.4-1.006-1.001-1.006h-24.63c-.602 0-1.002.403-1.002 1.006v2.617s0 .202-.2.202h-31.64c-.6 0-1.001.402-1.001 1.006v17.312s0 .201-.2.201h-11.415c-.2-.805-1-1.208-1.802-1.208a1.8 1.8 0 0 0-1.802 1.812 1.8 1.8 0 0 0 1.802 1.812c.801 0 1.602-.604 1.802-1.208h13.417s.2 0 .2.201v17.513c0 .604.4 1.006 1.002 1.006h34.843c.601 0 1.001-.402 1.001-1.006V23.753s0-.201.2-.201h2.003l-.4 1.811c0 .403.6.604.8.202l2.003-2.215c.2-.2.2-.402 0-.603l-2.002-2.416zm-3.405 20.532c0 .202-.2.403-.4.403h-34.243c-.2 0-.4-.201-.4-.403V23.552s0-.202.2-.202h2.403l-.4 1.812c0 .403.6.604.8.201l2.003-2.214c.2-.201.2-.402 0-.604l-2.003-2.214c-.2-.201-.8-.201-.8.201l.4 1.812h-4.406s-.2 0-.2-.201V5.033c0-.202.2-.403.2-.403h34.443c.401 0 .401.201.401.402v17.11s0 .202-.2.202h-3.805s0 .201-.2.403l-.4.402h6.207s.2 0 .2.201v17.513h.2zm41.452-16.305c-.2-.201-.4-.201-.6 0l-2.203 2.013c-.4.202-.2.805.2.805l1.802-.402v14.09c0 .202-.2.403-.4.403h-18.223c-.2 0-.4-.201-.4-.402V31.2c0-.201-.2-.403-.401-.403-.2 0-.4.202-.4.403v10.266c0 .604.4 1.007 1 1.007h18.824c.601 0 1.002-.403 1.002-1.007V27.175l1.802.403c.4 0 .6-.403.2-.805l-2.203-2.215zm7.61-2.013l-2.003-2.214c-.2-.201-.8-.201-.8.201l.4 1.812h-11.214V9.662h-5.807l-8.411 11.273-8.41-11.273h-5.808v26.37h5.007V16.91l8.61 11.474h1.002l8.81-11.474v19.123h5.007V23.35h11.214l-.4 1.812c0 .403.4.604.8.201l2.003-2.214c.2-.201.2-.402 0-.604z"
          mask="url(#b)"
        />
      </g>
    </svg>
  )
}

export function EnvyCrmBigIcon({width, height}) {
  return <img src="/images/ENVY.png" alt="ENVY" width={width} height={height}/>
}

export function AmoCrmMenuIcon({className, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M7.417 19.74c0 .227-.056.474-.168.739a2.668 2.668 0 0 1-.53.781c-.24.256-.548.463-.923.623-.374.16-.81.24-1.308.24-.378 0-.721-.037-1.03-.108a2.894 2.894 0 0 1-.843-.335 2.842 2.842 0 0 1-.696-.598 3.555 3.555 0 0 1-.483-.754 3.934 3.934 0 0 1-.3-.891 4.857 4.857 0 0 1-.1-1.006c0-.577.083-1.092.251-1.548.168-.456.408-.846.72-1.17.313-.324.679-.57 1.099-.74.42-.169.867-.253 1.343-.253.58 0 1.095.115 1.548.346.452.232.799.517 1.04.857.24.34.36.662.36.965a.629.629 0 0 1-.175.44.557.557 0 0 1-.425.19c-.185 0-.324-.044-.417-.132-.093-.088-.196-.24-.31-.454-.189-.355-.411-.62-.667-.796-.255-.176-.57-.264-.945-.264-.595 0-1.07.226-1.423.679-.353.452-.53 1.095-.53 1.928 0 .557.078 1.02.235 1.39.156.37.377.645.664.827.286.183.622.274 1.006.274.416 0 .769-.104 1.057-.31.288-.207.505-.51.652-.911.062-.189.138-.343.23-.461.09-.12.237-.179.439-.179.172 0 .32.06.444.181.124.12.185.27.185.45zm3.252-.802h-.507v2.3c0 .303-.067.526-.2.67a.681.681 0 0 1-.523.214c-.231 0-.41-.075-.537-.225-.127-.15-.19-.369-.19-.659V15.73c0-.312.07-.538.21-.678.14-.14.366-.21.678-.21h2.358c.326 0 .604.014.835.041.232.028.44.084.625.169a1.81 1.81 0 0 1 .99 1.018c.089.233.134.48.134.74 0 .533-.151.96-.452 1.279-.301.319-.758.545-1.37.679.257.136.503.338.738.605.234.267.443.551.627.852.184.301.327.573.43.816.102.242.153.409.153.5 0 .094-.03.188-.09.28a.633.633 0 0 1-.246.22.778.778 0 0 1-.362.081.704.704 0 0 1-.41-.115 1.103 1.103 0 0 1-.286-.29c-.08-.117-.188-.29-.324-.518l-.581-.967a5.32 5.32 0 0 0-.56-.81 1.38 1.38 0 0 0-.5-.381 1.72 1.72 0 0 0-.64-.103zm.83-3.007h-1.337v1.967h1.298c.349 0 .642-.03.88-.09.237-.06.418-.163.544-.308.125-.144.188-.344.188-.598a.924.924 0 0 0-.152-.525.915.915 0 0 0-.42-.339c-.169-.072-.502-.107-1-.107zm6.832 4.99l-1.148-4.56v4.94c0 .274-.06.48-.183.616a.62.62 0 0 1-.486.205.62.62 0 0 1-.478-.203c-.124-.135-.186-.34-.186-.617v-5.664c0-.313.081-.524.244-.633.163-.109.383-.163.66-.163h.449c.27 0 .466.024.588.073a.494.494 0 0 1 .271.264c.059.127.125.333.2.62l1.04 3.92 1.04-3.92c.075-.287.142-.493.2-.62a.494.494 0 0 1 .271-.264c.123-.049.319-.073.589-.073h.45c.276 0 .495.054.658.163.163.11.244.32.244.633v5.664c0 .273-.06.478-.183.615a.625.625 0 0 1-.49.205.61.61 0 0 1-.474-.205c-.124-.137-.186-.342-.186-.615V16.36l-1.147 4.56a9.223 9.223 0 0 1-.183.653.9.9 0 0 1-.261.378c-.127.114-.303.171-.528.171a.795.795 0 0 1-.43-.11.791.791 0 0 1-.273-.28 1.603 1.603 0 0 1-.154-.379 49.306 49.306 0 0 1-.114-.432zM3.01 12c.06.616-.198.924-.775.924S1.29 12.616 1.128 12A6.222 6.222 0 0 1 1 10.74c0-3.015 2.15-5.493 4.904-5.81C7.054 2.598 9.351 1 12 1c3.337 0 6.119 2.528 6.742 5.878C21.116 7.058 23 9.142 23 11.714c0 .096-.003.191-.008.286-.124.616-.48.924-1.07.924-.59 0-.844-.308-.763-.924a3.26 3.26 0 0 0 .008-.23c0-1.643-1.233-2.978-2.75-2.978h-1.375v-.497c0-3.019-2.255-5.462-5.042-5.462-2.31 0-4.249 1.683-4.849 3.972h-.65c-2.027 0-3.668 1.778-3.668 3.973 0 .426.062.837.177 1.222zm9.49-3.76v3.787a.5.5 0 1 1-1 0V8.299l-.995 1.013a.5.5 0 1 1-.714-.7l1.852-1.885a.5.5 0 0 1 .701-.013L14.332 8.6a.5.5 0 0 1-.688.726L12.5 8.24z"
      />
    </svg>
  )
}

export function AmoCrmBunnerIcon({width, height}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 80 72"
    >
      <g fill="#000" fillRule="evenodd">
        <path
          fillRule="nonzero"
          d="M22.25 35A21.901 21.901 0 0 1 18 22C18 9.85 27.85 0 40 0s22 9.85 22 22c0 4.863-1.578 9.358-4.25 13h-5.3A17.948 17.948 0 0 0 58 22c0-9.941-8.059-18-18-18s-18 8.059-18 18c0 5.11 2.13 9.724 5.55 13h-5.3zm8.42 0C26.63 32.096 24 27.355 24 22c0-8.837 7.163-16 16-16s16 7.163 16 16c0 5.355-2.63 10.096-6.67 13h-1.842C51.978 32.408 55 27.557 55 22c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 5.557 3.022 10.408 7.512 13H30.67z"
        />
        <path
          fillRule="nonzero"
          d="M40.72 23.365v3.213c1.358-.117 2.032-.713 2.032-1.582 0-.83-.518-1.25-2.031-1.63zm-1.122-2.92V17.33c-1.23.137-1.875.752-1.875 1.514 0 .761.566 1.25 1.875 1.601zm1.123.254l.693.156c2.666.596 4.063 1.68 4.063 3.829 0 2.46-1.983 3.964-4.756 4.16v1.543h-1.123v-1.533c-2.744-.166-4.727-1.612-4.805-4.053h2.617c.166.967.86 1.64 2.188 1.777v-3.467l-.655-.146c-2.548-.576-3.955-1.729-3.955-3.858 0-2.343 1.924-3.877 4.61-4.043v-1.572h1.123v1.572c2.715.206 4.482 1.739 4.57 4.063h-2.607c-.137-1.035-.87-1.63-1.963-1.787v3.36z"
        />
        <path
          fillRule="nonzero"
          d="M49.92 59l1.6 10H55a1.5 1.5 0 0 1 0 3H25a1.5 1.5 0 0 1 0-3h3.48l1.6-10H4a4 4 0 0 1-4-4V13a4 4 0 0 1 4-4h14.642a24.949 24.949 0 0 0-1.098 2H4a2 2 0 0 0-2 2v42a2 2 0 0 0 2 2h72a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2H62.456a24.949 24.949 0 0 0-1.098-2H76a4 4 0 0 1 4 4v42a4 4 0 0 1-4 4H49.92zm-2.025 0h-15.79l-1.6 10h18.99l-1.6-10z"
        />
        <path
          d="M7 53a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-18 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-48 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-18 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-48 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-18 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm36 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM25 32v3h30v-3h6a3 3 0 0 1 0 6H19a3 3 0 0 1 0-6h6z"/>
      </g>
    </svg>
  )
}

export function ComagicIcon({width, height}) {
  return (
    <svg
      version="1.1"
      id="Слой_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 440.3330078 143.265625"
      enableBackground="new 0 0 440.3330078 143.265625"
    >
      <g>
        <path
          fill="#7CC242"
          d="M133.6347656,33.8256836c-7.0664063-7.0664063-16.84375-10.2646484-26.8217773-8.7177734
		c-13.1782227,2.0175781-23.7915039,12.6308594-25.8085938,25.8095703
		c-1.5288086,9.9765625,1.6523438,19.7539063,8.7216797,26.8232422c5.9038086,5.9082031,13.6982422,9.0976563,21.9213867,9.0976563
		c1.6201172,0,3.2578125-0.1220703,4.8984375-0.3759766c13.175293-2.0146484,23.7919922-12.6308594,25.8125-25.8125
		C143.8867188,50.6733398,140.7050781,40.8950195,133.6347656,33.8256836 M129.6782227,58.7045898
		c-1.1625977,7.578125-7.5029297,13.9179688-15.0727539,15.0771484c-5.8964844,0.8984375-11.6538086-0.9589844-15.8076172-5.1123047
		c-4.1513672-4.1503906-6.0146484-9.9150391-5.1118164-15.8115234c1.1606445-7.5703125,7.4980469-13.9072266,15.0698242-15.0693359
		c5.918457-0.8896484,11.6533203,0.9619141,15.8076172,5.1113281
		C128.7128906,47.0512695,130.578125,52.8120117,129.6782227,58.7045898"
        />
        <path
          fill="#7CC242"
          d="M66.5043945,64.0766602c-5.8266602,6.3095703-14.1118164,9.9277344-22.7368164,9.9277344
		c-16.9907227,0-30.8144531-13.6992188-30.8144531-30.5361328c0-16.8408203,13.8237305-30.5390625,30.8144531-30.5390625
		c8.5839844,0,16.8447266,3.5898438,22.6650391,9.8486328c2.4213867,2.6064453,6.4780273,2.734375,9.0678711,0.3291016
		c2.5952148-2.4160156,2.7407227-6.4755859,0.3286133-9.0693359C67.5883789,5.1791992,55.9047852,0.0981445,43.7675781,0.0981445
		c-24.0673828,0-43.6455078,19.4560547-43.6455078,43.3701172c0,23.9130859,19.578125,43.3662109,43.6455078,43.3662109
		c12.1928711,0,23.9140625-5.1210938,32.1660156-14.0556641c2.4023438-2.5996094,2.2387695-6.6591797-0.3642578-9.0654297
		C72.9692383,61.3139648,68.9038086,61.4643555,66.5043945,64.0766602"
        />
        <path
          fill="#5E469C"
          d="M370.3505859,24.7319336c-3.5429688,0-6.4160156,2.8730469-6.4160156,6.4160156v49.2714844
		c0,3.5429688,2.8730469,6.4150391,6.4160156,6.4150391s6.4150391-2.8720703,6.4150391-6.4150391V31.1479492
		C376.765625,27.6049805,373.8935547,24.7319336,370.3505859,24.7319336"
        />
        <path
          fill="#5E469C"
          d="M365.7958984,5.0415039c-1.15625,1.21875-1.859375,2.8222656-1.859375,4.5546875
		s0.703125,3.3359375,1.859375,4.5546875c1.2197266,1.1552734,2.8867188,1.8603516,4.5556641,1.8603516
		c1.6669922,0,3.3369141-0.7050781,4.5546875-1.8603516c1.1513672-1.21875,1.8613281-2.8886719,1.8613281-4.5546875
		c0-1.6699219-0.7099609-3.3359375-1.8613281-4.5546875C372.4648438,2.6665039,368.1689453,2.6665039,365.7958984,5.0415039"
        />
        <path
          fill="#5E469C"
          d="M436.2998047,67.7104492c-2.6015625-2.3994141-6.6582031-2.2490234-9.0644531,0.3632813
		c-3.4794922,3.7685547-8.4326172,5.9306641-13.5849609,5.9306641c-10.1503906,0-18.4091797-8.1728516-18.4091797-18.2207031
		S403.5,37.5629883,413.6503906,37.5629883c5.2011719,0,10.0126953,2.0898438,13.5400391,5.8867188
		c2.4208984,2.5996094,6.4716797,2.7470703,9.0703125,0.328125c2.59375-2.4150391,2.7412109-6.4716797,0.3291016-9.0683594
		c-5.8984375-6.3398438-14.2617188-9.9775391-22.9394531-9.9775391c-17.2265625,0-31.2402344,13.9306641-31.2402344,31.0517578
		c0,17.1240234,14.0136719,31.0507813,31.2402344,31.0507813c8.7216797,0,17.109375-3.6650391,23.0146484-10.0585938
		C439.0673828,74.1762695,438.9023438,70.1166992,436.2998047,67.7104492"
        />
        <path
          fill="#5E469C"
          d="M358.2919922,31.1459961c0-3.5429688-2.8730469-6.4150391-6.4160156-6.4150391h-23.0976563
		c-0.1142578,0-0.2070313,0.0595703-0.3193359,0.0654297c-2.0078125-0.0751953-4.0390625-0.0058594-6.0869141,0.3115234
		c-13.1777344,2.0175781-23.7910156,12.6308594-25.8085938,25.8095703
		c-1.5283203,9.9765625,1.6523438,19.7539063,8.7226563,26.8232422c1.6757813,1.6777344,3.5332031,3.0722656,5.4804688,4.2998047
		c-1.4599609,2.3496094-2.2607422,4.9775391-2.2607422,7.6171875c0,2.3662109,0.6679688,4.71875,1.84375,6.8789063
		c-8.5048828,4.4462891-14.1601563,12.1074219-14.1601563,20.8369141c0,13.7236328,13.9267578,24.8916016,31.0478516,24.8916016
		c17.1220703,0,31.0546875-11.1679688,31.0546875-24.8916016c0-13.7265625-13.9326172-24.8935547-31.0546875-24.8935547
		c-3.3623047,0-5.9003906-1.2128906-5.9003906-2.8222656c0-1.6054688,2.5214844-2.8115234,5.8691406-2.8193359h0.0009766
		c1.6201172,0,3.2568359-0.1220703,4.8984375-0.3759766c13.1787109-2.0175781,23.7910156-12.6308594,25.8085938-25.8125
		c1.28125-8.3603516-0.7841797-16.5615234-5.6386719-23.1679688
		C355.6210938,37.2641602,358.2919922,34.5483398,358.2919922,31.1459961 M327.2373047,105.3110352
		c9.8789063,0,18.2236328,5.5253906,18.2236328,12.0625c0,6.5380859-8.3447266,12.0605469-18.2236328,12.0605469
		c-9.8769531,0-18.2177734-5.5224609-18.2177734-12.0605469
		C309.0195313,110.8364258,317.3603516,105.3110352,327.2373047,105.3110352 M345.2333984,58.7075195
		c-1.1621094,7.5751953-7.4990234,13.9121094-15.0683594,15.0722656c-5.9052734,0.9003906-11.65625-0.9570313-15.8085938-5.1103516
		c-4.1503906-4.1503906-6.0146484-9.9150391-5.1113281-15.8095703c1.1611328-7.5722656,7.4980469-13.9121094,15.0693359-15.0712891
		c0.9775391-0.1474609,1.9501953-0.2226563,2.9101563-0.2226563c4.8505859,0,9.4326172,1.8701172,12.8964844,5.3349609
		C344.2724609,47.050293,346.1357422,52.8120117,345.2333984,58.7075195"
        />
        <path
          fill="#5E469C"
          d="M281.4472656,33.8295898c-7.0664063-7.0703125-16.8496094-10.2685547-26.8222656-8.7216797
		c-13.1787109,2.0175781-23.7919922,12.6308594-25.8085938,25.8095703
		c-1.5292969,9.9765625,1.6523438,19.7539063,8.7226563,26.8232422c5.9023438,5.9082031,13.6982422,9.0976563,21.9208984,9.0976563
		c1.6201172,0,3.2568359-0.1220703,4.8974609-0.3759766c4.9511719-0.7587891,9.5390625-2.7304688,13.4453125-5.59375
		c0.2431641,3.3212891,2.9414063,5.9658203,6.3261719,5.9658203c3.5429688,0,6.4150391-2.8720703,6.4150391-6.4150391V56.753418
		c0-0.0507813-0.0283203-0.0927734-0.0292969-0.1416016C290.7460938,48.0776367,287.5576172,39.940918,281.4472656,33.8295898
		 M277.4882813,58.7075195c-1.1640625,7.5751953-7.5009766,13.9150391-15.0712891,15.0722656
		c-5.8984375,0.9003906-11.6523438-0.9570313-15.8076172-5.1103516c-4.1513672-4.1503906-6.0146484-9.9150391-5.1113281-15.8095703
		c1.1611328-7.5722656,7.4980469-13.9091797,15.0693359-15.0712891c5.9121094-0.8896484,11.6572266,0.9619141,15.8066406,5.1123047
		C276.5244141,47.050293,278.3886719,52.8120117,277.4882813,58.7075195"
        />
        <path
          fill="#5E469C"
          d="M217.6396484,0.2231445c-3.0009766-0.6015625-6.0048828,0.9990234-7.1806641,3.8222656
		l-24.8701172,59.6933594L160.7119141,4.0454102c-1.171875-2.8232422-4.1669922-4.4296875-7.1796875-3.8222656
		c-2.9970703,0.5986328-5.15625,3.2333984-5.15625,6.2900391v73.90625c0,3.5429688,2.8720703,6.4150391,6.4150391,6.4150391
		s6.4160156-2.8720703,6.4160156-6.4150391V38.5874023l18.4599609,44.3007813
		c0.9960938,2.3896484,3.3291016,3.9462891,5.921875,3.9462891c2.5898438,0,4.9228516-1.5566406,5.9199219-3.9462891
		l18.4560547-44.2978516v41.8291016c0,3.5429688,2.8730469,6.4150391,6.4160156,6.4150391
		c3.5439453,0,6.4160156-2.8720703,6.4160156-6.4150391v-73.90625C222.796875,3.456543,220.6367188,0.8217773,217.6396484,0.2231445
		"
        />
      </g>
    </svg>
  )
}

export function CalltrackingByIcon({width, height}) {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
         width={width} height={height} viewBox="0 0 2445.000000 392.000000"
         preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,392.000000) scale(0.100000,-0.100000)"
         fill="#000000" stroke="none">
        <path d="M2455 3896 c-299 -59 -546 -293 -650 -616 -37 -114 -46 -310 -20
-445 46 -244 190 -458 397 -589 l78 -49 -51 -96 c-122 -229 -272 -402 -487
-563 -43 -32 -80 -58 -84 -58 -3 0 -33 26 -65 58 -66 66 -182 151 -263 192
-261 132 -632 110 -878 -53 -190 -127 -331 -317 -393 -529 -30 -105 -37 -297
-14 -409 39 -193 114 -331 259 -474 205 -203 405 -274 741 -262 373 14 512 33
702 97 122 42 158 46 239 31 27 -5 116 -15 198 -22 119 -9 173 -9 268 1 106
12 120 11 136 -3 44 -40 110 -59 200 -56 58 2 107 -3 147 -14 95 -26 224 -37
453 -37 171 0 219 3 242 15 56 29 67 93 24 144 l-26 31 -216 1 c-120 1 -241 4
-270 7 l-54 7 21 27 c56 71 80 189 52 260 -17 45 -80 106 -127 124 -52 20
-121 14 -170 -15 -28 -17 -34 -18 -45 -5 -22 26 -89 37 -148 24 -43 -10 -64
-22 -101 -59 -50 -50 -74 -105 -86 -199 -5 -42 -11 -53 -28 -56 -58 -12 -124
-15 -192 -9 l-75 6 133 96 c172 125 493 430 626 595 437 543 684 1203 686
1826 0 187 -11 279 -50 430 -80 309 -285 528 -584 626 -78 25 -100 27 -270 30
-127 2 -207 -1 -255 -10z m381 -311 c160 -30 289 -118 361 -245 127 -223 137
-676 23 -1112 -41 -160 -82 -272 -155 -424 -276 -580 -721 -1065 -1203 -1312
-114 -59 -266 -113 -377 -136 -111 -22 -492 -49 -595 -42 -155 10 -286 66
-386 164 -113 112 -170 231 -181 377 -13 188 45 346 176 475 119 119 245 170
416 170 235 0 434 -119 533 -319 23 -46 42 -91 42 -100 0 -10 3 -20 6 -24 8
-7 176 76 271 134 231 141 467 370 627 609 108 160 256 505 256 595 0 23 -4
25 -43 25 -24 0 -68 7 -98 16 -203 60 -362 225 -414 429 -31 123 -11 304 48
425 39 79 156 205 226 243 115 63 302 84 467 52z m121 -3208 c-10 -29 -73 -84
-84 -74 -11 12 28 97 55 118 25 19 27 19 33 2 3 -10 2 -31 -4 -46z m-271 26
c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7 1 -15 -2 -18z"/>
        <path d="M2581 3465 c-36 -8 -89 -27 -119 -42 -72 -36 -163 -137 -210 -232
-36 -72 -37 -79 -37 -180 0 -131 17 -182 81 -241 72 -66 121 -83 223 -78 106
5 178 39 270 124 115 106 167 226 159 368 -11 206 -168 326 -367 281z"/>
        <path d="M836 1370 c-229 -41 -425 -309 -385 -528 26 -139 118 -233 249 -253
109 -17 264 42 345 133 123 137 173 312 129 458 -12 41 -29 67 -72 110 -75 73
-159 99 -266 80z"/>
        <path d="M7100 1830 l0 -1090 170 0 170 0 0 1090 0 1090 -170 0 -170 0 0
-1090z"/>
        <path d="M7870 1830 l0 -1090 170 0 170 0 0 1090 0 1090 -170 0 -170 0 0
-1090z"/>
        <path d="M14890 1830 l0 -1090 170 0 170 0 2 354 3 353 285 -353 285 -354 208
0 c164 0 207 3 200 13 -4 6 -151 177 -326 380 -206 238 -315 372 -310 380 4 6
140 167 302 357 l295 345 -185 3 c-101 1 -193 0 -204 -3 -11 -3 -139 -156
-285 -340 l-265 -335 -3 690 -2 690 -170 0 -170 0 0 -1090z"/>
        <path d="M21400 1830 l0 -1090 170 0 170 0 0 106 0 106 43 -56 c52 -69 128
-127 205 -157 78 -31 260 -38 353 -15 106 27 186 73 269 156 152 151 220 348
221 632 0 216 -35 360 -120 491 -101 154 -232 230 -421 244 -213 15 -383 -63
-507 -231 l-43 -58 0 481 0 481 -170 0 -170 0 0 -1090z m885 118 c96 -49 167
-151 194 -276 16 -74 13 -264 -4 -346 -32 -149 -115 -270 -224 -323 -49 -25
-67 -28 -151 -28 -82 0 -103 4 -151 27 -105 48 -179 144 -204 264 -17 80 -19
258 -5 359 13 85 54 178 105 234 85 93 158 123 295 118 79 -3 104 -8 145 -29z"/>
        <path d="M16555 2899 c-51 -12 -113 -62 -131 -105 -19 -46 -17 -122 4 -163 9
-19 34 -48 55 -65 36 -29 44 -31 121 -31 75 0 86 2 120 29 21 15 46 42 56 58
87 143 -54 316 -225 277z"/>
        <path d="M10068 2602 l-158 -46 0 -168 0 -168 -120 0 -120 0 0 -135 0 -135
120 0 120 0 0 -432 c0 -253 5 -460 11 -498 33 -209 170 -310 421 -310 102 0
185 13 231 36 l27 15 0 129 0 130 -39 -20 c-120 -63 -269 -15 -300 95 -7 26
-11 182 -11 447 l0 408 173 2 172 3 0 130 0 130 -172 3 -173 2 0 215 c0 166
-3 215 -12 214 -7 -1 -84 -22 -170 -47z"/>
        <path d="M4730 2240 c-258 -41 -453 -186 -561 -415 -56 -121 -74 -214 -74
-385 1 -167 20 -253 83 -375 53 -101 183 -230 282 -278 128 -63 218 -80 394
-74 160 5 235 21 339 73 l47 24 0 140 c0 77 -2 140 -4 140 -2 0 -30 -16 -62
-35 -86 -52 -158 -76 -249 -82 -148 -10 -273 36 -364 132 -87 92 -131 212
-131 360 0 302 196 515 474 515 104 0 183 -21 269 -70 l67 -38 0 154 0 154
-27 12 c-118 47 -348 70 -483 48z"/>
        <path d="M5949 2236 c-99 -18 -203 -51 -281 -90 l-63 -31 -3 -148 -3 -148 48
36 c112 86 284 145 421 145 181 0 288 -89 300 -249 l4 -66 -238 -34 c-131 -18
-266 -40 -299 -48 -196 -49 -329 -176 -366 -351 -6 -33 -9 -96 -7 -150 5 -81
10 -102 42 -167 76 -154 207 -225 416 -225 100 0 172 15 244 52 50 26 137 108
176 166 l30 45 0 -116 0 -117 166 0 165 0 -4 548 c-3 482 -6 554 -21 606 -52
177 -159 285 -329 333 -73 20 -303 26 -398 9z m419 -898 c-4 -146 -20 -190
-98 -272 -72 -77 -131 -101 -245 -101 -69 0 -98 4 -125 19 -83 44 -120 104
-120 195 0 117 52 183 169 218 57 16 331 60 390 62 l33 1 -4 -122z"/>
        <path d="M12376 2240 c-94 -15 -201 -47 -287 -87 l-79 -36 0 -148 0 -149 52
39 c110 84 235 129 378 138 132 8 198 -11 261 -76 48 -50 79 -129 79 -202 l0
-35 -237 -33 c-249 -34 -357 -57 -426 -92 -169 -85 -248 -219 -248 -419 0 -54
6 -115 15 -142 41 -135 148 -236 291 -274 59 -16 221 -18 284 -3 106 24 222
106 283 201 l33 51 3 -117 3 -116 159 0 160 0 0 533 c0 576 -3 611 -55 721
-52 111 -150 190 -285 231 -65 20 -295 29 -384 15z m402 -897 c-3 -100 -8
-127 -30 -175 -57 -124 -161 -197 -292 -206 -164 -10 -270 73 -270 213 1 116
40 174 147 213 51 19 339 68 416 71 l33 1 -4 -117z"/>
        <path d="M14034 2236 c-168 -32 -278 -89 -395 -206 -71 -71 -93 -101 -132
-180 -55 -112 -76 -189 -85 -314 -20 -274 44 -472 205 -633 56 -56 94 -82 165
-118 117 -57 200 -75 356 -75 139 0 228 16 340 62 l72 30 0 144 c0 79 -2 144
-4 144 -3 0 -25 -13 -49 -30 -99 -66 -214 -97 -330 -87 -209 18 -350 135 -402
334 -20 75 -19 242 0 318 36 138 126 250 252 312 67 33 83 37 176 41 79 3 117
0 162 -13 64 -18 150 -58 178 -83 16 -14 17 -7 17 141 0 181 9 165 -118 198
-100 27 -308 34 -408 15z"/>
        <path d="M17887 2234 c-122 -29 -224 -99 -304 -207 l-43 -59 0 126 0 126 -165
0 -165 0 0 -740 0 -740 165 0 165 0 0 453 c0 377 3 463 16 512 29 115 94 199
188 245 51 25 76 31 132 32 98 1 150 -18 206 -73 35 -35 52 -63 70 -115 22
-68 23 -77 26 -561 l3 -493 164 0 165 0 0 514 c0 575 -3 615 -65 744 -60 127
-168 212 -303 241 -70 15 -183 13 -255 -5z"/>
        <path d="M19337 2234 c-202 -44 -355 -181 -440 -395 -45 -114 -58 -185 -64
-359 -4 -142 -2 -179 16 -265 51 -249 216 -440 422 -490 99 -24 281 -17 362
14 111 43 193 111 280 231 17 24 18 21 13 -125 -8 -217 -42 -321 -136 -409
-168 -157 -480 -169 -764 -30 -39 19 -73 34 -78 34 -4 0 -8 -67 -8 -149 l0
-150 57 -21 c149 -56 214 -65 448 -64 195 0 229 3 299 22 237 66 405 224 470
442 43 141 46 213 46 973 l0 727 -165 0 -165 0 0 -107 -1 -108 -22 30 c-81
111 -190 183 -306 205 -74 14 -183 11 -264 -6z m391 -287 c71 -37 129 -98 166
-177 l31 -65 0 -200 c0 -169 -3 -209 -19 -255 -39 -115 -114 -202 -215 -248
-47 -22 -71 -26 -146 -26 -77 -1 -98 3 -146 26 -151 70 -229 227 -229 457 1
271 93 438 278 508 25 9 69 12 132 10 80 -3 103 -8 148 -30z"/>
        <path d="M11478 2216 c-31 -13 -75 -37 -97 -55 -47 -37 -111 -130 -138 -198
l-18 -48 -5 150 -5 150 -162 3 -163 2 0 -740 0 -740 165 0 165 0 0 403 c0 434
5 486 54 593 34 73 114 156 178 184 44 19 65 22 137 18 54 -3 98 -11 119 -21
l32 -18 0 159 0 159 -39 11 c-64 20 -159 14 -223 -12z"/>
        <path d="M16440 1480 l0 -740 165 0 165 0 0 740 0 740 -165 0 -165 0 0 -740z"/>
        <path d="M22970 2215 c0 -3 131 -335 291 -738 l290 -732 -37 -95 c-83 -213
-143 -290 -248 -320 -47 -13 -181 -10 -218 5 -17 7 -18 -4 -18 -133 l0 -139
31 -7 c56 -11 233 -6 285 8 160 42 310 180 409 376 38 76 693 1768 687 1775
-3 3 -77 5 -164 5 l-159 0 -13 -32 c-21 -52 -363 -1058 -377 -1108 l-12 -45
-14 50 c-24 83 -355 1099 -365 1118 -8 15 -27 17 -188 17 -99 0 -180 -2 -180
-5z"/>
        <path d="M8630 1545 l0 -125 390 0 390 0 0 125 0 125 -390 0 -390 0 0 -125z"/>
        <path d="M20767 1087 c-86 -28 -137 -97 -137 -187 0 -60 16 -96 64 -137 45
-41 96 -56 162 -51 128 11 217 140 173 255 -12 34 -64 89 -100 108 -38 20
-119 26 -162 12z"/>
      </g>
    </svg>
  )
}

export function UonCrmBigIcon({width, height}) {
  return (
    <svg
      version={1.0}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 211.000000 83.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,83.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M56 811 c-55 -36 -55 -39 -56 -394 0 -287 2 -332 16 -357 36 -59 41
-60 399 -60 358 0 363 1 399 60 14 25 16 70 16 357 -1 355 -1 358 -56 394 -27
18 -50 19 -359 19 -309 0 -332 -1 -359 -19z m280 -311 c0 -214 0 -215 20 -234
21 -21 92 -21 116 1 16 15 18 35 18 215 l0 198 80 0 80 0 0 -189 c0 -228 -9
-286 -49 -323 -41 -37 -89 -48 -206 -48 -116 0 -174 20 -198 67 -10 21 -16 89
-21 261 l-6 233 83 -3 82 -3 1 -175z"
        />
        <path
          d="M1190 691 c-127 -27 -209 -128 -218 -266 -6 -101 15 -163 82 -231 77
-79 173 -102 285 -68 74 21 143 88 172 163 40 106 17 232 -57 320 -53 64 -175
101 -264 82z m120 -166 c49 -25 76 -96 60 -156 -25 -91 -135 -130 -198 -71
-113 106 3 297 138 227z"
        />
        <path
          d="M1645 681 l-60 -6 0 -272 0 -273 82 0 83 0 -6 140 c-4 77 -5 140 -2
140 3 0 54 -63 112 -140 l107 -140 70 0 69 0 0 108 c0 60 3 184 7 275 l6 167
-83 0 -83 0 6 -145 c4 -121 3 -144 -9 -135 -7 7 -59 74 -115 151 -57 76 -107
138 -113 137 -6 -1 -38 -4 -71 -7z"
        />
      </g>
    </svg>
  )
}

export function GetCourseBigIcon({width, height}) {
  return (
    <img src="/images/getcourse.png" width={width} height={height} alt=""/>
  )
}

export function CustomCrmBigIcon({width, height}) {
  return (
    <img src="/images/test_custom.png" width={width} height={height} alt=""/>
  )
}

export function LogoutIcon({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="nonzero"
        d="M19.604 13H9.5c-1.333 0-1.333-2 0-2h10.104L17.31 8.707c-.943-.943.471-2.357 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4c-.943.943-2.357-.471-1.414-1.414L19.604 13zm-3.975-9.51a1 1 0 1 1-.801 1.832 7.273 7.273 0 0 0-8.064 1.526 7.287 7.287 0 0 0 8.063 11.834 1 1 0 1 1 .799 1.834A9.288 9.288 0 0 1 5.35 5.434 9.273 9.273 0 0 1 15.629 3.49z"
      />
    </svg>
  )
}

export function YclientsIcon({width, height}) {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
         width={width} height={height} viewBox="0 0 148.000000 28.000000"
         preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,28.000000) scale(0.100000,-0.100000)"
         fill="#000000" stroke="none">
        <path d="M50 222 c0 -5 8 -33 18 -63 12 -35 16 -65 12 -86 -8 -37 -5 -43 26
-43 17 0 25 9 34 37 7 21 30 61 51 90 46 62 48 73 12 73 -21 0 -34 -10 -53
-36 l-24 -36 -11 33 c-9 26 -18 35 -38 37 -15 2 -27 -1 -27 -6z"/>
        <path d="M345 220 c-32 -12 -45 -33 -58 -95 -11 -55 -11 -58 13 -77 19 -16 35
-19 68 -15 50 5 65 17 56 41 -5 13 -14 15 -39 10 -41 -7 -49 5 -35 56 11 43
34 53 43 20 4 -16 10 -18 28 -11 23 8 40 44 31 69 -5 14 -75 16 -107 2z"/>
        <path d="M473 138 c-11 -51 -18 -96 -16 -100 2 -5 31 -8 63 -8 48 0 61 4 70
19 15 29 13 31 -30 31 -37 0 -40 2 -35 23 14 63 25 113 25 120 0 4 -13 7 -28
7 -28 0 -29 -2 -49 -92z"/>
        <path d="M645 208 c-2 -13 -12 -54 -20 -92 -16 -73 -12 -91 21 -84 20 3 38 57
50 151 6 46 6 47 -20 47 -18 0 -27 -6 -31 -22z"/>
        <path d="M725 218 c-2 -7 -11 -50 -18 -96 -17 -97 -18 -95 69 -90 52 3 59 5
62 26 3 20 -1 22 -37 22 -30 0 -41 4 -41 15 0 11 11 15 39 15 26 0 41 5 45 16
9 25 -1 32 -39 29 -25 -3 -35 1 -35 11 0 10 13 14 44 14 43 0 65 18 50 41 -8
14 -134 11 -139 -3z"/>
        <path d="M875 140 c-10 -49 -18 -93 -19 -97 0 -5 11 -9 26 -11 23 -3 28 1 34
25 17 77 17 77 45 26 19 -37 31 -49 52 -51 17 -2 29 2 33 12 12 31 41 176 36
181 -3 3 -16 5 -28 5 -18 0 -25 -7 -30 -27 -3 -16 -9 -41 -14 -58 l-7 -30 -29
58 c-24 48 -32 57 -55 57 -25 0 -27 -4 -44 -90z"/>
        <path d="M1107 223 c-4 -3 -7 -15 -7 -25 0 -13 7 -18 25 -18 21 0 25 -4 20
-22 -31 -136 -31 -130 2 -126 28 3 34 16 57 121 5 20 12 27 30 27 22 0 36 16
36 41 0 10 -153 13 -163 2z"/>
        <path d="M1297 218 c-11 -8 -19 -28 -20 -48 -2 -31 2 -36 36 -52 45 -22 40
-43 -9 -35 -27 5 -36 2 -45 -14 -14 -27 -9 -30 45 -36 65 -8 98 15 94 65 -2
31 -8 39 -35 51 -45 20 -41 35 7 28 33 -4 40 -2 46 15 8 26 2 30 -53 35 -31 3
-54 0 -66 -9z"/>
      </g>
    </svg>
  )
}

export function MegaplanIcon({width, height}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 150 29"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(-225.000000, -42.000000)">
          <g id="logo-cyrillic-29" transform="translate(225.000000, 42.000000)">
            <g id="Group">
              <path
                d="M6.72,25.468 C6.64848726,25.4677994 6.57786709,25.452106 6.513,25.422 C6.263,25.307 6.106,25.256 6.221,25.006 L9.461,17.831 C9.51370526,17.7155071 9.60901322,17.624857 9.727,17.578 L11.197,16.983 C11.362414,16.9160127 11.5510001,16.9423612 11.6917198,17.0521202 C11.8324394,17.1618793 11.903914,17.3383739 11.8792198,17.5151202 C11.8545255,17.6918666 11.737414,17.8420127 11.572,17.909 L10.286,18.429 L7.131,25.426 C7.045,25.608 6.911,25.469 6.721,25.469 L6.72,25.468 Z"
                id="Shape"
                fill="#2A2A2A"
              />
              <polygon
                id="Shape"
                fill="#2A2A2A"
                points="11.484 17.938 11.204 17.241 44.994 3.595 8.36 14.342 8.15 13.622 47.546 2.72 11.484 17.937"
              />
              <path
                d="M32.7,19.2 C32.4906502,19.2000161 32.3034551,19.0696078 32.2309266,18.8732231 C32.1583982,18.6768384 32.2158942,18.4560613 32.375,18.32 L52.54,1 L10.555,1 L2.16,8.552 L8.91,13.472 C8.94753335,13.4997015 8.98116847,13.5323276 9.01,13.569 L11.778,17.139 C11.948,17.357 11.908,17.671 11.69,17.839 C11.4718379,18.0077891 11.1583581,17.968939 10.988,17.752 L8.263,14.24 L1.073,9 C0.951365541,8.91079957 0.876287197,8.77163345 0.868532394,8.6209964 C0.860777591,8.47035935 0.921168357,8.32421928 1.033,8.223 L10.03,0.127 C10.1210239,0.0448551488 10.2393911,-0.000423896093 10.362,2.22043334e-16 L53.9,2.22043334e-16 C54.11,2.22043334e-16 54.285,0.13 54.358,0.325 C54.4306747,0.521099589 54.3736265,0.741712483 54.215,0.878 L33.025,19.078 C32.934612,19.155764 32.8192355,19.1983645 32.7,19.198 L32.7,19.2 Z"
                id="Shape"
                fill="#2A2A2A"
              />
              <polyline
                id="Shape"
                fill="#44AC5A"
                points="6.22 25.006 4.285 29 21.435 29 26 25"
              />
              <path
                d="M40.88,25 L40.88,11.997 L33.406,18.567 L29.493,11.797 L26,11.797 L26,25 L28.907,25 L28.907,16.52 L32.081,22.348 L34.881,22.348 L37.975,16.575 L37.975,25 L40.882,25 L40.88,25 Z M149.128,24.975 L149.128,11.8 L146.141,11.8 L146.141,16.893 L139.663,16.893 L139.663,11.8 L136.649,11.8 L136.649,24.973 L139.663,24.973 L139.663,19.613 L146.143,19.613 L146.143,24.973 L149.129,24.973 L149.129,24.975 L149.128,24.975 Z M104.484,19.08 C104.379,21.08 104.271,21.64 103.978,22.04 C103.658,22.387 103.286,22.6 102.726,22.6 C102.513,22.6 102.084,22.575 102.084,22.575 L102.084,25.108 C102.404,25.134 102.99,25.188 103.364,25.188 C104.458,25.188 105.417,25.028 106.031,24.468 C106.644,23.908 107.285,23.188 107.443,20.494 C107.499,19.507 107.683,14.52 107.683,14.52 L112.883,14.52 L112.883,25 L115.898,25 L115.898,11.8 L104.67,11.8 C104.646,12.732 104.593,17.16 104.484,19.08 L104.484,19.08 Z M82.378,21.453 L82.378,11.88 C81.898,11.8 80.004,11.532 77.204,11.532 C71.924,11.532 69.15,14.492 69.15,18.919 C69.15,21.079 69.71,22.625 70.67,23.689 C71.763,24.891 73.443,25.371 74.75,25.371 C78.19,25.371 79.417,23.265 79.417,23.265 L79.523,23.318 C79.523,23.318 79.496,23.453 79.496,23.665 C79.496,25.025 80.883,25.345 82.083,25.345 C83.391,25.345 84.109,25.24 84.109,25.24 L84.109,22.68 C83.949,22.706 83.815,22.706 83.522,22.706 C82.91,22.706 82.377,22.6 82.377,21.453 L82.378,21.453 Z M79.363,19.025 C79.363,20.785 77.683,22.705 75.523,22.705 C74.295,22.705 73.523,22.173 72.963,21.478 C72.563,20.892 72.268,19.906 72.268,18.812 C72.268,17.424 72.668,16.092 73.521,15.265 C74.189,14.598 75.469,14.119 77.098,14.119 C78.162,14.119 79.364,14.331 79.364,14.331 L79.364,19.024 L79.363,19.025 Z M59.203,11.8 L59.203,25 L62.243,25 L62.243,14.52 L68.056,14.52 L68.056,11.8 L59.202,11.8 L59.203,11.8 Z M87.15,11.8 L87.15,25 L90.164,25 L90.164,14.52 L96.724,14.52 L96.724,25 L99.766,25 L99.766,11.8 L87.15,11.8 Z M50.322,11.452 C48.428,11.452 47.042,11.905 45.735,13.132 C44.375,14.386 43.628,16.172 43.628,18.44 C43.628,20.467 44.321,22.336 45.521,23.48 C46.829,24.76 48.856,25.4 51.549,25.4 C52.963,25.4 54.349,25.162 55.443,24.815 L55.443,22.44 C54.83,22.546 53.256,22.813 51.576,22.813 C50.002,22.813 48.856,22.575 48.109,21.987 C47.549,21.559 46.909,20.893 46.696,19.639 L56.163,19.639 C56.269,19.051 56.323,18.171 56.323,17.211 C56.323,13.905 54.056,11.451 50.323,11.451 L50.322,11.452 Z M46.748,17.105 C46.908,16.145 47.281,15.345 47.841,14.785 C48.376,14.252 49.256,13.932 50.296,13.932 C51.31,13.932 51.976,14.252 52.536,14.786 C53.043,15.346 53.283,16.279 53.283,17.106 L46.749,17.106 L46.748,17.105 Z M131.848,21.453 L131.848,11.88 C131.368,11.8 129.475,11.532 126.674,11.532 C121.394,11.532 118.621,14.492 118.621,18.919 C118.621,21.079 119.183,22.625 120.143,23.689 C121.235,24.891 122.913,25.371 124.223,25.371 C127.661,25.371 128.889,23.265 128.889,23.265 L128.995,23.318 C128.995,23.318 128.969,23.453 128.969,23.665 C128.969,25.025 130.359,25.345 131.557,25.345 C132.864,25.345 133.583,25.24 133.583,25.24 L133.583,22.68 C133.423,22.706 133.289,22.706 132.995,22.706 C132.381,22.706 131.849,22.6 131.849,21.453 L131.848,21.453 Z M128.834,19.025 C128.834,20.785 127.152,22.705 124.994,22.705 C123.767,22.705 122.994,22.173 122.434,21.478 C122.034,20.892 121.741,19.906 121.741,18.812 C121.741,17.424 122.168,16.119 122.995,15.265 C123.688,14.625 124.94,14.119 126.567,14.119 C127.633,14.119 128.835,14.331 128.835,14.331 L128.835,19.024 L128.834,19.025 Z"
                id="Shape"
                fill="#2A2A2A"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function DishIcon({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 16"
    >
      <path
        fill="#000"
        fillRule="evenodd"
        d="M11 3.05V2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2v1.05c5.053.501 9 4.765 9 9.95H2c0-5.185 3.947-9.449 9-9.95zM1 14h22a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2zm8.834-9.48a8.764 8.764 0 0 0-6.325 6.358.75.75 0 0 0 1.456.363 7.264 7.264 0 0 1 5.24-5.267.75.75 0 1 0-.37-1.454z"
      />
    </svg>
  )
}

export function CallTrackingMenuIcon({className, width, height}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M22.1 12.33l.796-.881a.635.635 0 0 1 .894-.047c.26.232.281.63.048.89l-1.899 2.1a.635.635 0 0 1-.945-.005l-1.864-2.1a.628.628 0 0 1 .056-.89.635.635 0 0 1 .893.056l.7.789c-.138-4.947-4.225-8.93-9.228-8.93-5.09 0-9.232 4.123-9.232 9.188s4.142 9.188 9.232 9.188a9.29 9.29 0 0 0 2.462-.331c1.15-.512 1.886-1.718 1.878-3.008a2.319 2.319 0 0 1-.22.056 9.996 9.996 0 0 1-7.137-2.903 9.91 9.91 0 0 1-2.918-7.127s.097-.428.247-.576l.845-.841c.31-.31.903-.449 1.319-.31l.178.059c.414.138.85.594.964 1.015l.425 1.552c.115.422-.04 1.021-.349 1.329l-.564.561a5.977 5.977 0 0 0 4.213 4.194l.564-.561c.31-.309.913-.463 1.336-.349l1.56.424c.422.116.88.547 1.02.96l.059.179c.138.412-.001 1.003-.31 1.31l-.021.02a4.617 4.617 0 0 1-2.647 5.249c-1.002.283-1.949.41-2.904.41C5.733 23 1 18.29 1 12.5S5.733 2 11.55 2c5.761 0 10.458 4.618 10.55 10.33z"
      />
    </svg>
  )
}

export function ChatMenuIcon({className, width, height}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
      width={24}
      height={24}
      viewBox="0 0 612 612"
    >
      <g>
        <g id="_x32__26_">
          <g>
            <path
              d="M401.625,325.125h-191.25c-10.557,0-19.125,8.568-19.125,19.125s8.568,19.125,19.125,19.125h191.25
				c10.557,0,19.125-8.568,19.125-19.125S412.182,325.125,401.625,325.125z M439.875,210.375h-267.75
				c-10.557,0-19.125,8.568-19.125,19.125s8.568,19.125,19.125,19.125h267.75c10.557,0,19.125-8.568,19.125-19.125
				S450.432,210.375,439.875,210.375z M306,0C137.012,0,0,119.875,0,267.75c0,84.514,44.848,159.751,114.75,208.826V612
				l134.047-81.339c18.552,3.061,37.638,4.839,57.203,4.839c169.008,0,306-119.875,306-267.75C612,119.875,475.008,0,306,0z
				 M306,497.25c-22.338,0-43.911-2.601-64.643-7.019l-90.041,54.123l1.205-88.701C83.5,414.133,38.25,345.513,38.25,267.75
				c0-126.741,119.875-229.5,267.75-229.5c147.875,0,267.75,102.759,267.75,229.5S453.875,497.25,306,497.25z"
            />
          </g>
        </g>
      </g>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
      <g/>
    </svg>
  )
}

export function CallTrackingIcon({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <rect width={80} height={80} fill="#FC0" rx={40}/>
        <path
          fill="#000"
          d="M64.997 39.594l1.886-2.097a1.5 1.5 0 1 1 2.23 2.006l-4.498 5a1.5 1.5 0 0 1-2.24-.01l-4.416-5a1.5 1.5 0 0 1 2.249-1.986l1.658 1.878C61.54 27.607 51.855 18.125 40 18.125c-12.06 0-21.875 9.814-21.875 21.875 0 12.06 9.814 21.875 21.875 21.875 1.984 0 3.946-.266 5.835-.787 2.725-1.218 4.468-4.09 4.45-7.163a5.473 5.473 0 0 1-.522.134 23.626 23.626 0 0 1-16.91-6.912 23.652 23.652 0 0 1-6.916-16.968c0-.003.23-1.019.586-1.373l2.002-2.002c.733-.735 2.14-1.068 3.125-.738l.422.14c.982.33 2.014 1.416 2.285 2.417l1.008 3.696c.271 1.004-.095 2.432-.828 3.164l-1.336 1.337a14.196 14.196 0 0 0 9.982 9.985l1.337-1.336c.735-.736 2.163-1.102 3.164-.83l3.696 1.01c1.001.274 2.087 1.3 2.417 2.282l.14.428c.327.982-.003 2.39-.735 3.119l-.049.048c1.163 5.121-1.462 10.37-6.271 12.497-2.375.675-4.618.977-6.882.977-13.785 0-25-11.215-25-25s11.215-25 25-25c13.649 0 24.779 10.995 24.997 24.594z"
        />
      </g>
    </svg>
  )
}

export function ChatTrackingIcon({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <rect width={80} height={80} fill="#FC0" rx={40}/>
        <path
          fill="#000"
          d="M15.46 39.594C15.676 25.995 26.704 15 40.23 15 53.887 15 65 26.215 65 40S53.887 65 40.229 65c-2.244 0-1.966-3.125 0-3.125 11.95 0 21.675-9.814 21.675-21.875 0-12.06-9.725-21.875-21.675-21.875-11.747 0-21.343 9.482-21.667 21.26l1.643-1.878a1.477 1.477 0 0 1 2.098-.131 1.51 1.51 0 0 1 .13 2.117l-4.376 5a1.477 1.477 0 0 1-2.219.01l-4.457-5a1.51 1.51 0 0 1 .111-2.118 1.477 1.477 0 0 1 2.1.112l1.868 2.097zM32.647 54h-1.47l.882-1.219c.647-.928 1.117-2.031 1.353-3.482C29.235 47.442 27 43.96 27 39.375 27 32.353 32.353 28 41 28s14 4.353 14 11.375c0 7.08-5.235 11.375-14 11.375h-.588C39 52.259 36.647 54 32.647 54zM33 43a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm8 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm8 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
        />
      </g>
    </svg>
  )
}

export function ArrowAside({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 63 83"
    >
      <path
        fill="#BBB"
        fillRule="nonzero"
        d="M4.525 3.417l-3.45 6.4-.88-.475L4.972.48l5.091 8.686-.863.506L5.525 3.4l.108 6.064C7.388 57.564 26.488 81.5 63 81.5v1C25.884 82.5 6.406 58.09 4.633 9.491l-.108-6.074z"
      />
    </svg>
  )
}

export function Setting({className, width, height, fill}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={fill}
        strokeWidth={2}
        d="M21.857 8.56l-1.865-3.138-2.987 1.167-.445-.333a7.32 7.32 0 0 0-1.682-.95l-.535-.213-.084-.57L13.887 2h-3.769l-.456 3.093-.535.213a7.736 7.736 0 0 0-1.692.957l-.443.323-.51-.2-2.469-.964-1.865 3.139 2.518 1.915-.074.573c-.047.368-.07.671-.07.951 0 .28.023.583.07.95l.074.574-.46.35-2.058 1.565 1.865 3.14L7 17.41l.445.333a7.32 7.32 0 0 0 1.682.95l.535.213.084.57.372 2.523h3.769l.456-3.093.535-.213a7.736 7.736 0 0 0 1.692-.957l.443-.323.51.2 2.469.964 1.865-3.139-2.518-1.915.074-.573c.048-.375.07-.664.07-.951 0-.287-.022-.576-.07-.95l-.074-.574.46-.35 2.058-1.565zm-2.05-3.45l-.014-.024a.535.535 0 0 0 .013.023zm-5.978-3.501l-.003-.02.003.02zM4.2 18.89l.013.023a.535.535 0 0 0-.013-.023zm5.977 3.5l.003.02a.527.527 0 0 0-.003-.02zm3.656-.016a.453.453 0 0 0-.003.017l.003-.017zm5.983-3.5a.374.374 0 0 0-.01.017l.01-.017zM12 16c-2.207 0-4-1.793-4-4s1.793-4 4-4 4 1.793 4 4-1.793 4-4 4z"
      />
    </svg>
  )
}

export function Visa({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 26 9"
    >
      {' '}
      <g className="icon__fill" fillRule="evenodd">
        {' '}
        <path
          d="M9.328 8.466L10.616.353h2.055l-1.28 8.113H9.33zM18.843.553C18.256.323 17.63.207 17 .21c-2.032 0-3.463 1.1-3.475 2.68-.013 1.166 1.022 1.816 1.8 2.203.802.398 1.07.652 1.068 1.006-.005.54-.64.79-1.23.79-.823 0-1.262-.13-1.937-.43l-.265-.13-.28 1.815c.48.226 1.37.422 2.29.43 2.16 0 3.567-1.085 3.58-2.77.01-.924-.54-1.626-1.73-2.204-.72-.377-1.16-.625-1.15-1.006 0-.337.373-.698 1.178-.698.53-.013 1.057.093 1.54.31l.185.094.277-1.76v.01zm2.74 5.037c.17-.465.818-2.268.818-2.268-.01.02.17-.47.28-.773l.14.7s.398 1.93.478 2.34H21.59zM24.12.362h-1.59c-.493 0-.86.143-1.078.67l-3.054 7.44h2.16c0-.003.352-1.002.432-1.223h2.635c.06.28.25 1.212.25 1.212h1.91L24.12.36v.002zM7.602.36L5.59 5.89l-.216-1.123C4.998 3.472 3.83 2.07 2.526 1.363l1.84 7.098h2.177l3.24-8.1h-2.18z"/>
        {' '}
        <path d="M3.72.355H.406L.38.525c2.58.67 4.286 2.292 4.995 4.242l-.72-3.727C4.53.525 4.168.373 3.72.355"/>
      </g>
    </svg>
  )
}

export function MasterCard({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 19 13"
    >
      {' '}
      <g fill="none">
        {' '}
        <rect
          width={19}
          height={13}
          fill="#333"
          fillOpacity=".25"
          rx="6.5"
        />
        {' '}
        <path
          fill="#FBB735"
          d="M9.5 11.074c.897.605 1.954.928 3.036.926C15.554 12 18 9.538 18 6.5S15.554 1 12.536 1c-1.082-.002-2.14.32-3.036.926 1.52 1.025 2.432 2.74 2.43 4.574.002 1.834-.91 3.55-2.43 4.574z"
        />
        {' '}
        <path
          fill="#F03727"
          d="M9.5 1.926C8.603 1.32 7.546.998 6.464 1 3.446 1 1 3.462 1 6.5S3.446 12 6.464 12c1.082.002 2.14-.32 3.036-.926C7.98 10.05 7.068 8.334 7.07 6.5c0-1.907.966-3.587 2.43-4.574z"
        />
        {' '}
        <path
          fill="#F6772D"
          d="M9.5 1.926c1.52 1.025 2.432 2.74 2.43 4.574.002 1.834-.91 3.55-2.43 4.574C7.98 10.05 7.068 8.334 7.07 6.5c0-1.907.966-3.587 2.43-4.574z"
        />
      </g>
    </svg>
  )
}

export function CiclePlus({className, width, height, fill}) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z"
      />
    </svg>
  )
}

export function CicleMinus({className, width, height, fill}) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-12v-2h12v2z"
      />
    </svg>
  )
}

export function Handshake({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.062 13.875l-1.625-5.979 3.367-1.092c-1.939-4.022-6.04-6.804-10.804-6.804-4.779 0-8.894 2.801-10.824 6.845l3.386 1.051-1.625 5.979-2.937-.767c.56 6.108 5.747 10.892 12 10.892s11.439-4.784 12-10.892l-2.938.767zm-14.826 1.845c-.314-.231-.382-.673-.151-.987l.806-1.088c.23-.313.67-.383.986-.151.316.231.383.672.152.987l-.807 1.087c-.217.298-.687.37-.986.152zm1.424 1.04c-.313-.232-.387-.664-.156-.978l.812-1.096c.229-.313.67-.381.984-.151.315.23.385.673.152.986l-.812 1.097c-.212.292-.672.366-.98.142zm1.426 1.04c-.313-.231-.383-.673-.151-.988l.805-1.086c.233-.315.674-.382.987-.152.314.231.383.673.151.987l-.805 1.088c-.218.296-.686.372-.987.151zm3.217-.201l-.807 1.092c-.215.294-.682.374-.986.151-.314-.231-.383-.672-.152-.986l.809-1.092c.229-.311.67-.382.986-.149.314.228.382.671.15.984zm.743 1.401c-.142 0-.296-.033-.451-.113.235-.318.579-.742.707-1.044l.159.159c.487.487.127.998-.415.998zm4.922-2.979c-.275.276-.723.276-.998 0l-2.025-2.025c-.065-.067-.174-.069-.243-.005-.075.067-.078.184-.006.255l1.875 1.876c.276.276.276.722 0 .998-.275.276-.723.276-.998 0l-1.523-1.524c-.068-.068-.178-.069-.247-.002-.072.069-.072.183-.003.252l1.264 1.265c.276.276.276.722 0 .999-.274.275-.722.276-.997 0l-.654-.654c.17-1.042-.595-1.891-1.53-1.972-.248-.591-.803-.985-1.422-1.039-.238-.571-.784-.984-1.424-1.04-.506-1.208-2.158-1.432-2.95-.351l-.44.595c-.449-.169-.934-.31-1.489-.441l1.273-4.685c1.899-.017 3.396-1.817 5.149-.709-.574.71-1.045 1.277-1.755 1.691-.567.332-.833.981-.66 1.616.216.797 1.024 1.354 1.968 1.354 1.248 0 2.54-1.025 3.521-1.761.578.577 3.831 3.775 4.315 4.31.274.274.274.72-.001.997zm.495-1.954s-3.125-3.084-4.053-4.013c-.496-.494-.838-.562-1.41-.101-.728.586-1.619 1.182-2.277 1.413-1.291.452-1.996-.647-1.396-.999 1.22-.711 1.814-1.737 2.839-2.898.284-.322.623-.441.969-.441.376 0 .761.14 1.095.312 1.517.784 2.897 1.319 4.351 1.212l1.296 4.768c-.464.208-.931.45-1.414.747z"/>
    </svg>
  )
}

export function Rub({className, width, height, fill}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        strokeWidth={1}
        d="M5 24v-5h-4v-3h4v-2h-4v-3h4v-11h8.464c3.698 0 6.143 0 8.16 2.623.89 1.158 1.376 2.69 1.376 4.257 0 2.176-.931 4.312-2.771 5.592-1.891 1.316-3.759 1.528-7.57 1.528h-3.659v2h7v3h-7v5h-4zm4-13h6.249c5.668 0 6.32-8-.324-8h-5.925v8z"
      />
    </svg>
  )
}

export function Important({className, width, height}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        d="M24 17.981h-13l-7 5.02v-5.02h-4v-16.981h24v16.981zm-2-14.981h-20v12.981h4v3.125l4.357-3.125h11.643v-12.981zm-9 6.001v5h-2v-5h2zm-1-1.5c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25-1.25.56-1.25 1.25.56 1.25 1.25 1.25z"/>
    </svg>
  )
}

export function Like({className, width, height, fill}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <path
        fill={fill}
        d="M29.6,13.3c-0.8-0.9-1.9-1.4-3.1-1.4h-6.4V7.5c0-1.9-0.9-3.8-2.5-4.9C16.9,2,15.9,1.8,15,2.1c-0.9,0.2-1.7,0.8-2,1.7L8.3,13.9H5c-1.7,0-3.1,1.4-3.1,3.1v10c0,1.7,1.4,3.1,3.1,3.1h2.9H9h15.9c2,0,3.7-1.5,4-3.5l1.6-10C30.7,15.4,30.4,14.2,29.6,13.3z M5,27.9c-0.5,0-0.9-0.4-0.9-0.9V17c0-0.5,0.4-0.9,0.9-0.9h2.9v11.8C7.9,27.9,5,27.9,5,27.9z M28.4,16.3l-1.6,10c-0.1,0.9-0.9,1.6-1.9,1.6H10.1V15.2L15,4.7c0.2-0.3,0.4-0.5,0.6-0.5c0.2,0,0.5-0.1,0.8,0.2c1,0.7,1.6,1.9,1.6,3.2v6.6h8.6c0.6,0,1.1,0.2,1.5,0.7C28.3,15.2,28.5,15.7,28.4,16.3z"
      />
    </svg>
  )
}
